/* tslint:disable */
/* eslint-disable */
/**
 * WoofWoofPublic
 * Public API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 *
 * @export
 * @interface AvailabilitySlotDto
 */
export interface AvailabilitySlotDto {
    /**
     * Start time of the availability slot
     * @type {string}
     * @memberof AvailabilitySlotDto
     */
    'start': string;
    /**
     * End time of the availability slot
     * @type {string}
     * @memberof AvailabilitySlotDto
     */
    'end': string;
    /**
     * Weekday (0 = Sunday, 6 = Saturday)
     * @type {number}
     * @memberof AvailabilitySlotDto
     */
    'weekday': number;
}
/**
 *
 * @export
 * @interface BlogPostAuthorDto
 */
export interface BlogPostAuthorDto {
    /**
     *
     * @type {number}
     * @memberof BlogPostAuthorDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostAuthorDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostAuthorDto
     */
    'slug': string;
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof BlogPostAuthorDto
     */
    'avatar_urls': { [key: string]: string; };
}
/**
 *
 * @export
 * @interface BlogPostDto
 */
export interface BlogPostDto {
    /**
     *
     * @type {number}
     * @memberof BlogPostDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'date': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'date_gmt': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'modified': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'slug': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'status': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'type': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'link': string;
    /**
     *
     * @type {BlogPostRenderedDto}
     * @memberof BlogPostDto
     */
    'title': BlogPostRenderedDto;
    /**
     *
     * @type {BlogPostProtectedRenderedDto}
     * @memberof BlogPostDto
     */
    'content': BlogPostProtectedRenderedDto;
    /**
     *
     * @type {BlogPostProtectedRenderedDto}
     * @memberof BlogPostDto
     */
    'excerpt': BlogPostProtectedRenderedDto;
    /**
     *
     * @type {number}
     * @memberof BlogPostDto
     */
    'author': number;
    /**
     *
     * @type {number}
     * @memberof BlogPostDto
     */
    'featured_media': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'comment_status': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'ping_status': string;
    /**
     *
     * @type {boolean}
     * @memberof BlogPostDto
     */
    'sticky': boolean;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'template': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostDto
     */
    'format': string;
    /**
     *
     * @type {Array<number>}
     * @memberof BlogPostDto
     */
    'categories': Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof BlogPostDto
     */
    'tags': Array<number>;
    /**
     *
     * @type {BlogPostEmbeddedDto}
     * @memberof BlogPostDto
     */
    '_embedded'?: BlogPostEmbeddedDto;
}
/**
 *
 * @export
 * @interface BlogPostEmbeddedDto
 */
export interface BlogPostEmbeddedDto {
    /**
     *
     * @type {Array<BlogPostAuthorDto>}
     * @memberof BlogPostEmbeddedDto
     */
    'author'?: Array<BlogPostAuthorDto>;
    /**
     *
     * @type {Array<BlogPostFeaturedMediaDto>}
     * @memberof BlogPostEmbeddedDto
     */
    'wp:featuredmedia'?: Array<BlogPostFeaturedMediaDto>;
}
/**
 *
 * @export
 * @interface BlogPostFeaturedMediaDto
 */
export interface BlogPostFeaturedMediaDto {
    /**
     *
     * @type {number}
     * @memberof BlogPostFeaturedMediaDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostFeaturedMediaDto
     */
    'source_url': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostFeaturedMediaDto
     */
    'alt_text': string;
    /**
     *
     * @type {BlogPostRenderedDto}
     * @memberof BlogPostFeaturedMediaDto
     */
    'caption': BlogPostRenderedDto;
    /**
     *
     * @type {BlogPostMediaDetailsDto}
     * @memberof BlogPostFeaturedMediaDto
     */
    'media_details': BlogPostMediaDetailsDto;
}
/**
 *
 * @export
 * @interface BlogPostMediaDetailsDto
 */
export interface BlogPostMediaDetailsDto {
    /**
     *
     * @type {{ [key: string]: BlogPostMediaSizeDto; }}
     * @memberof BlogPostMediaDetailsDto
     */
    'sizes': { [key: string]: BlogPostMediaSizeDto; };
}
/**
 *
 * @export
 * @interface BlogPostMediaSizeDto
 */
export interface BlogPostMediaSizeDto {
    /**
     *
     * @type {string}
     * @memberof BlogPostMediaSizeDto
     */
    'source_url': string;
    /**
     *
     * @type {number}
     * @memberof BlogPostMediaSizeDto
     */
    'width': number;
    /**
     *
     * @type {number}
     * @memberof BlogPostMediaSizeDto
     */
    'height': number;
}
/**
 *
 * @export
 * @interface BlogPostProtectedRenderedDto
 */
export interface BlogPostProtectedRenderedDto {
    /**
     *
     * @type {string}
     * @memberof BlogPostProtectedRenderedDto
     */
    'rendered': string;
    /**
     *
     * @type {boolean}
     * @memberof BlogPostProtectedRenderedDto
     */
    'protected': boolean;
}
/**
 *
 * @export
 * @interface BlogPostRenderedDto
 */
export interface BlogPostRenderedDto {
    /**
     *
     * @type {string}
     * @memberof BlogPostRenderedDto
     */
    'rendered': string;
}
/**
 *
 * @export
 * @interface BlogPostResponseDto
 */
export interface BlogPostResponseDto {
    /**
     *
     * @type {number}
     * @memberof BlogPostResponseDto
     */
    'id': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'date': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'date_gmt': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'modified': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'slug': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'status': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'type': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'link': string;
    /**
     *
     * @type {BlogPostRenderedDto}
     * @memberof BlogPostResponseDto
     */
    'title': BlogPostRenderedDto;
    /**
     *
     * @type {BlogPostProtectedRenderedDto}
     * @memberof BlogPostResponseDto
     */
    'content': BlogPostProtectedRenderedDto;
    /**
     *
     * @type {BlogPostProtectedRenderedDto}
     * @memberof BlogPostResponseDto
     */
    'excerpt': BlogPostProtectedRenderedDto;
    /**
     *
     * @type {number}
     * @memberof BlogPostResponseDto
     */
    'author': number;
    /**
     *
     * @type {number}
     * @memberof BlogPostResponseDto
     */
    'featured_media': number;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'comment_status': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'ping_status': string;
    /**
     *
     * @type {boolean}
     * @memberof BlogPostResponseDto
     */
    'sticky': boolean;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'template': string;
    /**
     *
     * @type {string}
     * @memberof BlogPostResponseDto
     */
    'format': string;
    /**
     *
     * @type {Array<number>}
     * @memberof BlogPostResponseDto
     */
    'categories': Array<number>;
    /**
     *
     * @type {Array<number>}
     * @memberof BlogPostResponseDto
     */
    'tags': Array<number>;
    /**
     *
     * @type {BlogPostEmbeddedDto}
     * @memberof BlogPostResponseDto
     */
    '_embedded'?: BlogPostEmbeddedDto;
}
/**
 *
 * @export
 * @interface BlogPostsListResponseDto
 */
export interface BlogPostsListResponseDto {
    /**
     *
     * @type {Array<BlogPostDto>}
     * @memberof BlogPostsListResponseDto
     */
    'posts': Array<BlogPostDto>;
    /**
     *
     * @type {number}
     * @memberof BlogPostsListResponseDto
     */
    'totalCount': number;
    /**
     *
     * @type {number}
     * @memberof BlogPostsListResponseDto
     */
    'totalPages': number;
    /**
     *
     * @type {number}
     * @memberof BlogPostsListResponseDto
     */
    'currentPage': number;
}
/**
 *
 * @export
 * @interface ClinicContactDto
 */
export interface ClinicContactDto {
    /**
     * Name of the clinic
     * @type {string}
     * @memberof ClinicContactDto
     */
    'clinicName'?: string;
    /**
     * First name of the contact person
     * @type {string}
     * @memberof ClinicContactDto
     */
    'firstName'?: string;
    /**
     * Last name of the contact person
     * @type {string}
     * @memberof ClinicContactDto
     */
    'lastName'?: string;
    /**
     * Email address of the contact person. Required unless a phone number is given.
     * @type {string}
     * @memberof ClinicContactDto
     */
    'email'?: string;
    /**
     * Phone number of the contact person. Required unless an email is given.
     * @type {string}
     * @memberof ClinicContactDto
     */
    'phone'?: string;
    /**
     * Website URL of the clinic (optional)
     * @type {string}
     * @memberof ClinicContactDto
     */
    'website'?: string;
    /**
     * Additional question or message (optional)
     * @type {string}
     * @memberof ClinicContactDto
     */
    'question'?: string;
}
/**
 *
 * @export
 * @interface GetCityDto
 */
export interface GetCityDto {
    /**
     * City name
     * @type {string}
     * @memberof GetCityDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface GetLastBookedVisitDto
 */
export interface GetLastBookedVisitDto {
    /**
     * Time of the last booked visit
     * @type {string}
     * @memberof GetLastBookedVisitDto
     */
    'time': string;
    /**
     * Whether the visit was booked today
     * @type {boolean}
     * @memberof GetLastBookedVisitDto
     */
    'isToday': boolean;
}
/**
 *
 * @export
 * @interface GetOrganizationDto
 */
export interface GetOrganizationDto {
    /**
     * Organization ID
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'id': string;
    /**
     * Organization name
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'name': string;
    /**
     * Street address
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'street': string;
    /**
     * ZIP code
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'zip': string;
    /**
     * City name
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'city': string;
    /**
     * Website URL
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'website': string | null;
    /**
     * Organization description
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'description': string;
    /**
     * Phone number
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'phoneNumber': string;
    /**
     * Email address
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'email': string | null;
    /**
     * Logo URL
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'logoUrl': string;
    /**
     * Array of image URLs
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'images': Array<string>;
    /**
     * Working hours availability slots
     * @type {Array<AvailabilitySlotDto>}
     * @memberof GetOrganizationDto
     */
    'workingHours': Array<AvailabilitySlotDto>;
    /**
     * Time off periods
     * @type {Array<TimeOffDto>}
     * @memberof GetOrganizationDto
     */
    'timeOff': Array<TimeOffDto>;
    /**
     * Organization specializations
     * @type {Array<OrganizationSpecializationDto>}
     * @memberof GetOrganizationDto
     */
    'specializations': Array<OrganizationSpecializationDto>;
    /**
     * Social media URLs
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'socialMedia': Array<string>;
    /**
     * Enabled visit types for the organization
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'enabledVisitTypes': Array<string>;
    /**
     * Enabled categories for the organization
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'enabledCategories': Array<string>;
    /**
     * Visit type category configurations
     * @type {Array<string>}
     * @memberof GetOrganizationDto
     */
    'visitTypeCategoryConfigs'?: Array<string>;
    /**
     * Organization slug
     * @type {string}
     * @memberof GetOrganizationDto
     */
    'slug'?: string;
}
/**
 *
 * @export
 * @interface GetOrganizationProfessionalsDto
 */
export interface GetOrganizationProfessionalsDto {
    /**
     * Professional ID
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'id': string;
    /**
     * Professional first name
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'firstName': string;
    /**
     * Professional last name
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'lastName': string;
    /**
     * Professional avatar URL
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'avatar'?: string;
    /**
     * Professional categories with pricing
     * @type {Array<ProfessionalCategoryDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'categories': Array<ProfessionalCategoryDto>;
    /**
     * Supported visit types by this professional
     * @type {Array<string>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'visitTypes': Array<GetOrganizationProfessionalsDtoVisitTypesEnum>;
    /**
     * Professional specializations
     * @type {Array<ProfessionalSpecializationDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'specializations': Array<ProfessionalSpecializationDto>;
    /**
     * Professional description
     * @type {string}
     * @memberof GetOrganizationProfessionalsDto
     */
    'description'?: string;
    /**
     * Professional organization-specific availability slots
     * @type {Array<AvailabilitySlotDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'availabilitySlots': Array<AvailabilitySlotDto>;
    /**
     * Professional service configurations
     * @type {Array<ServiceConfigDto>}
     * @memberof GetOrganizationProfessionalsDto
     */
    'services': Array<ServiceConfigDto>;
}

export const GetOrganizationProfessionalsDtoVisitTypesEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type GetOrganizationProfessionalsDtoVisitTypesEnum = typeof GetOrganizationProfessionalsDtoVisitTypesEnum[keyof typeof GetOrganizationProfessionalsDtoVisitTypesEnum];

/**
 *
 * @export
 * @interface GetProfessionalsSlotsDto
 */
export interface GetProfessionalsSlotsDto {
    /**
     *
     * @type {string}
     * @memberof GetProfessionalsSlotsDto
     */
    'organizationId': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalsSlotsDto
     */
    'startDate': string;
    /**
     *
     * @type {string}
     * @memberof GetProfessionalsSlotsDto
     */
    'endDate': string;
    /**
     *
     * @type {number}
     * @memberof GetProfessionalsSlotsDto
     */
    'slotsPerDay'?: number;
    /**
     *
     * @type {Array<ProfessionalSlotsRequestDto>}
     * @memberof GetProfessionalsSlotsDto
     */
    'professionals': Array<ProfessionalSlotsRequestDto>;
}
/**
 *
 * @export
 * @interface GetSpecializationDto
 */
export interface GetSpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof GetSpecializationDto
     */
    'id': string;
    /**
     * Specialization display name
     * @type {string}
     * @memberof GetSpecializationDto
     */
    'name': string;
    /**
     * Visit category ID this specialization belongs to
     * @type {string}
     * @memberof GetSpecializationDto
     */
    'visitCategoryId': string;
}
/**
 *
 * @export
 * @interface GuestAttachmentClaimDto
 */
export interface GuestAttachmentClaimDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof GuestAttachmentClaimDto
     */
    'uploadToken'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestAttachmentClaimDto
     */
    'filename': string;
    /**
     *
     * @type {string}
     * @memberof GuestAttachmentClaimDto
     */
    'originalFilename'?: string;
}
/**
 *
 * @export
 * @interface GuestAttachmentResponseDto
 */
export interface GuestAttachmentResponseDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof GuestAttachmentResponseDto
     */
    'uploadToken'?: string;
    /**
     * Storage filename of the uploaded private file
     * @type {string}
     * @memberof GuestAttachmentResponseDto
     */
    'filename': string;
    /**
     * Short-lived (60 min) signed URL for previewing the file before the booking-submit claim creates the canonical Document row
     * @type {string}
     * @memberof GuestAttachmentResponseDto
     */
    'url': string;
}
/**
 *
 * @export
 * @interface GuestBookingConfirmDto
 */
export interface GuestBookingConfirmDto {
    /**
     *
     * @type {string}
     * @memberof GuestBookingConfirmDto
     */
    'confirmationId': string;
    /**
     *
     * @type {string}
     * @memberof GuestBookingConfirmDto
     */
    'code': string;
}
/**
 *
 * @export
 * @interface GuestBookingConfirmationPendingResponseDto
 */
export interface GuestBookingConfirmationPendingResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestBookingConfirmationPendingResponseDto
     */
    'confirmationId': string;
    /**
     *
     * @type {Array<string>}
     * @memberof GuestBookingConfirmationPendingResponseDto
     */
    'channels': Array<GuestBookingConfirmationPendingResponseDtoChannelsEnum>;
    /**
     *
     * @type {string}
     * @memberof GuestBookingConfirmationPendingResponseDto
     */
    'expiresAt': string;
}

export const GuestBookingConfirmationPendingResponseDtoChannelsEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type GuestBookingConfirmationPendingResponseDtoChannelsEnum = typeof GuestBookingConfirmationPendingResponseDtoChannelsEnum[keyof typeof GuestBookingConfirmationPendingResponseDtoChannelsEnum];

/**
 *
 * @export
 * @interface GuestCancelVisitDto
 */
export interface GuestCancelVisitDto {
    /**
     * Optional reason for cancelling the visit
     * @type {string}
     * @memberof GuestCancelVisitDto
     */
    'reason'?: string;
}
/**
 *
 * @export
 * @interface GuestContactChangeCompleteDto
 */
export interface GuestContactChangeCompleteDto {
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeCompleteDto
     */
    'challengeId': string;
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeCompleteDto
     */
    'code': string;
}
/**
 *
 * @export
 * @interface GuestContactChangeCompleteResponseDto
 */
export interface GuestContactChangeCompleteResponseDto {
    /**
     *
     * @type {number}
     * @memberof GuestContactChangeCompleteResponseDto
     */
    'changed': GuestContactChangeCompleteResponseDtoChangedEnum;
}

export const GuestContactChangeCompleteResponseDtoChangedEnum = {
    NUMBER_null: null
} as const;

export type GuestContactChangeCompleteResponseDtoChangedEnum = typeof GuestContactChangeCompleteResponseDtoChangedEnum[keyof typeof GuestContactChangeCompleteResponseDtoChangedEnum];

/**
 *
 * @export
 * @interface GuestContactChangeStartDto
 */
export interface GuestContactChangeStartDto {
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeStartDto
     */
    'replacementContact': string;
}
/**
 *
 * @export
 * @interface GuestContactChangeStartResponseDto
 */
export interface GuestContactChangeStartResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeStartResponseDto
     */
    'challengeId': string;
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeStartResponseDto
     */
    'maskedDestination': string;
    /**
     *
     * @type {string}
     * @memberof GuestContactChangeStartResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface GuestDocumentFileEntryDto
 */
export interface GuestDocumentFileEntryDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof GuestDocumentFileEntryDto
     */
    'uploadToken'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestDocumentFileEntryDto
     */
    'filename'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestDocumentFileEntryDto
     */
    'url'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestDocumentFileEntryDto
     */
    'originalFilename'?: string;
}
/**
 *
 * @export
 * @interface GuestManageLinkStartDto
 */
export interface GuestManageLinkStartDto {
    /**
     * Nieprzezroczysty identyfikator linku do zarządzania rezerwacją głosową.
     * @type {string}
     * @memberof GuestManageLinkStartDto
     */
    'handle': string;
}
/**
 *
 * @export
 * @interface GuestManageLinkStartResponseDto
 */
export interface GuestManageLinkStartResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestManageLinkStartResponseDto
     */
    'visitId': string;
    /**
     *
     * @type {string}
     * @memberof GuestManageLinkStartResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GuestManageLinkStartResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface GuestPaymentStatusResponseDto
 */
export interface GuestPaymentStatusResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestPaymentStatusResponseDto
     */
    'status': GuestPaymentStatusResponseDtoStatusEnum;
    /**
     *
     * @type {number}
     * @memberof GuestPaymentStatusResponseDto
     */
    'amount': number;
    /**
     *
     * @type {string}
     * @memberof GuestPaymentStatusResponseDto
     */
    'paymentUrl': string | null;
}

export const GuestPaymentStatusResponseDtoStatusEnum = {
    Created: 'created',
    Verified: 'verified',
    Failed: 'failed',
    Refunded: 'refunded'
} as const;

export type GuestPaymentStatusResponseDtoStatusEnum = typeof GuestPaymentStatusResponseDtoStatusEnum[keyof typeof GuestPaymentStatusResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface GuestRateVisitDto
 */
export interface GuestRateVisitDto {
    /**
     *
     * @type {number}
     * @memberof GuestRateVisitDto
     */
    'professionalRating': number;
    /**
     *
     * @type {number}
     * @memberof GuestRateVisitDto
     */
    'organizationRating': number;
    /**
     *
     * @type {string}
     * @memberof GuestRateVisitDto
     */
    'review'?: string;
}
/**
 *
 * @export
 * @interface GuestRejectVisitDto
 */
export interface GuestRejectVisitDto {
    /**
     * Optional reason for rejecting the visit
     * @type {string}
     * @memberof GuestRejectVisitDto
     */
    'reason'?: string;
}
/**
 *
 * @export
 * @interface GuestRescheduleVisitDto
 */
export interface GuestRescheduleVisitDto {
    /**
     * New visit start time (ISO 8601)
     * @type {string}
     * @memberof GuestRescheduleVisitDto
     */
    'startTime': string;
    /**
     * Optional professional ID to reassign the visit to. If omitted, the same professional is retained.
     * @type {string}
     * @memberof GuestRescheduleVisitDto
     */
    'professionalId'?: string;
}
/**
 *
 * @export
 * @interface GuestUpdateProfileDataDto
 */
export interface GuestUpdateProfileDataDto {
    /**
     *
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'name'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'breed'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'petCategory'?: GuestUpdateProfileDataDtoPetCategoryEnum;
    /**
     *
     * @type {number}
     * @memberof GuestUpdateProfileDataDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'gender'?: string;
    /**
     * ISO-8601 date
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateProfileDataDto
     */
    'chipNumber'?: string;
}

export const GuestUpdateProfileDataDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type GuestUpdateProfileDataDtoPetCategoryEnum = typeof GuestUpdateProfileDataDtoPetCategoryEnum[keyof typeof GuestUpdateProfileDataDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface GuestUpdateReminderDto
 */
export interface GuestUpdateReminderDto {
    /**
     *
     * @type {string}
     * @memberof GuestUpdateReminderDto
     */
    'description'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateReminderDto
     */
    'scheduledAt'?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof GuestUpdateReminderDto
     */
    'notificationChannels'?: Array<GuestUpdateReminderDtoNotificationChannelsEnum>;
}

export const GuestUpdateReminderDtoNotificationChannelsEnum = {
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;

export type GuestUpdateReminderDtoNotificationChannelsEnum = typeof GuestUpdateReminderDtoNotificationChannelsEnum[keyof typeof GuestUpdateReminderDtoNotificationChannelsEnum];

/**
 *
 * @export
 * @interface GuestUpdateUserDataDto
 */
export interface GuestUpdateUserDataDto {
    /**
     *
     * @type {string}
     * @memberof GuestUpdateUserDataDto
     */
    'firstName'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateUserDataDto
     */
    'lastName'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateUserDataDto
     */
    'email'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestUpdateUserDataDto
     */
    'phoneNumber'?: string;
}
/**
 *
 * @export
 * @interface GuestUpdateVisitDetailsDto
 */
export interface GuestUpdateVisitDetailsDto {
    /**
     *
     * @type {string}
     * @memberof GuestUpdateVisitDetailsDto
     */
    'description'?: string;
    /**
     *
     * @type {Array<GuestDocumentFileEntryDto>}
     * @memberof GuestUpdateVisitDetailsDto
     */
    'documentsToAdd'?: Array<GuestDocumentFileEntryDto>;
    /**
     *
     * @type {Array<string>}
     * @memberof GuestUpdateVisitDetailsDto
     */
    'documentIdsToRemove'?: Array<string>;
}
/**
 *
 * @export
 * @interface GuestVerifyCompleteDto
 */
export interface GuestVerifyCompleteDto {
    /**
     *
     * @type {string}
     * @memberof GuestVerifyCompleteDto
     */
    'challengeId': string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyCompleteDto
     */
    'code'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyCompleteDto
     */
    'nonce'?: string;
}
/**
 *
 * @export
 * @interface GuestVerifyCompleteResponseDto
 */
export interface GuestVerifyCompleteResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestVerifyCompleteResponseDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyCompleteResponseDto
     */
    'expiresAt': string;
}
/**
 *
 * @export
 * @interface GuestVerifyStartDto
 */
export interface GuestVerifyStartDto {
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartDto
     */
    'guestAccessToken'?: string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartDto
     */
    'channel'?: GuestVerifyStartDtoChannelEnum;
}

export const GuestVerifyStartDtoChannelEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type GuestVerifyStartDtoChannelEnum = typeof GuestVerifyStartDtoChannelEnum[keyof typeof GuestVerifyStartDtoChannelEnum];

/**
 *
 * @export
 * @interface GuestVerifyStartResponseDto
 */
export interface GuestVerifyStartResponseDto {
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartResponseDto
     */
    'challengeId': string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartResponseDto
     */
    'channel': GuestVerifyStartResponseDtoChannelEnum;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartResponseDto
     */
    'maskedDestination': string;
    /**
     *
     * @type {string}
     * @memberof GuestVerifyStartResponseDto
     */
    'expiresAt': string;
}

export const GuestVerifyStartResponseDtoChannelEnum = {
    Email: 'email',
    Sms: 'sms'
} as const;

export type GuestVerifyStartResponseDtoChannelEnum = typeof GuestVerifyStartResponseDtoChannelEnum[keyof typeof GuestVerifyStartResponseDtoChannelEnum];

/**
 *
 * @export
 * @interface OrganizationSpecializationDto
 */
export interface OrganizationSpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof OrganizationSpecializationDto
     */
    'id': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof OrganizationSpecializationDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface ProductCheckDto
 */
export interface ProductCheckDto {
    /**
     *
     * @type {string}
     * @memberof ProductCheckDto
     */
    'productName': string;
    /**
     *
     * @type {string}
     * @memberof ProductCheckDto
     */
    'productDescription': string;
    /**
     *
     * @type {string}
     * @memberof ProductCheckDto
     */
    'productIngredients': string;
    /**
     *
     * @type {string}
     * @memberof ProductCheckDto
     */
    'petCategory': ProductCheckDtoPetCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof ProductCheckDto
     */
    'petBreed': string;
}

export const ProductCheckDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat'
} as const;

export type ProductCheckDtoPetCategoryEnum = typeof ProductCheckDtoPetCategoryEnum[keyof typeof ProductCheckDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface ProductCheckResponseDto
 */
export interface ProductCheckResponseDto {
    /**
     *
     * @type {object}
     * @memberof ProductCheckResponseDto
     */
    'recommendation': object;
    /**
     *
     * @type {string}
     * @memberof ProductCheckResponseDto
     */
    'reasoning': string;
    /**
     *
     * @type {number}
     * @memberof ProductCheckResponseDto
     */
    'suitabilityScore': number;
    /**
     *
     * @type {Array<string>}
     * @memberof ProductCheckResponseDto
     */
    'considerations': Array<string>;
    /**
     *
     * @type {string}
     * @memberof ProductCheckResponseDto
     */
    'response': string;
    /**
     *
     * @type {string}
     * @memberof ProductCheckResponseDto
     */
    'callToAction': string;
}
/**
 *
 * @export
 * @interface ProductImageDto
 */
export interface ProductImageDto {
    /**
     * Image ID
     * @type {number}
     * @memberof ProductImageDto
     */
    'id': number;
    /**
     * Date created
     * @type {string}
     * @memberof ProductImageDto
     */
    'date_created': string;
    /**
     * Date modified
     * @type {string}
     * @memberof ProductImageDto
     */
    'date_modified': string;
    /**
     * Image source URL
     * @type {string}
     * @memberof ProductImageDto
     */
    'src': string;
    /**
     * Image name
     * @type {string}
     * @memberof ProductImageDto
     */
    'name': string;
    /**
     * Image alt text
     * @type {string}
     * @memberof ProductImageDto
     */
    'alt': string;
}
/**
 *
 * @export
 * @interface ProductResponseDto
 */
export interface ProductResponseDto {
    /**
     * Product ID
     * @type {number}
     * @memberof ProductResponseDto
     */
    'id': number;
    /**
     * Product name
     * @type {string}
     * @memberof ProductResponseDto
     */
    'name': string;
    /**
     * Product slug
     * @type {string}
     * @memberof ProductResponseDto
     */
    'slug': string;
    /**
     * Product permalink
     * @type {string}
     * @memberof ProductResponseDto
     */
    'permalink': string;
    /**
     * Date created
     * @type {string}
     * @memberof ProductResponseDto
     */
    'date_created': string;
    /**
     * Date modified
     * @type {string}
     * @memberof ProductResponseDto
     */
    'date_modified': string;
    /**
     * Product type
     * @type {string}
     * @memberof ProductResponseDto
     */
    'type': string;
    /**
     * Product status
     * @type {string}
     * @memberof ProductResponseDto
     */
    'status': string;
    /**
     * Featured status
     * @type {boolean}
     * @memberof ProductResponseDto
     */
    'featured': boolean;
    /**
     * Product catalog visibility
     * @type {string}
     * @memberof ProductResponseDto
     */
    'catalog_visibility': string;
    /**
     * Product description
     * @type {string}
     * @memberof ProductResponseDto
     */
    'description': string;
    /**
     * Short description
     * @type {string}
     * @memberof ProductResponseDto
     */
    'short_description': string;
    /**
     * SKU
     * @type {string}
     * @memberof ProductResponseDto
     */
    'sku': string;
    /**
     * Product price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'price': string;
    /**
     * Regular price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'regular_price': string;
    /**
     * Sale price
     * @type {string}
     * @memberof ProductResponseDto
     */
    'sale_price': string;
    /**
     * Product stock status
     * @type {string}
     * @memberof ProductResponseDto
     */
    'stock_status': string;
    /**
     * Product images
     * @type {Array<ProductImageDto>}
     * @memberof ProductResponseDto
     */
    'images': Array<ProductImageDto>;
    /**
     * Product categories
     * @type {Array<object>}
     * @memberof ProductResponseDto
     */
    'categories': Array<object>;
    /**
     * Product tags
     * @type {Array<object>}
     * @memberof ProductResponseDto
     */
    'tags': Array<object>;
}
/**
 *
 * @export
 * @interface ProductsListResponseDto
 */
export interface ProductsListResponseDto {
    /**
     * List of products
     * @type {Array<ProductResponseDto>}
     * @memberof ProductsListResponseDto
     */
    'products': Array<ProductResponseDto>;
    /**
     * Total number of products
     * @type {number}
     * @memberof ProductsListResponseDto
     */
    'totalCount': number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof ProductsListResponseDto
     */
    'totalPages': number;
}
/**
 *
 * @export
 * @interface ProfessionalCategoryDto
 */
export interface ProfessionalCategoryDto {
    /**
     * Category name
     * @type {string}
     * @memberof ProfessionalCategoryDto
     */
    'name': ProfessionalCategoryDtoNameEnum;
    /**
     * Price for this category
     * @type {number}
     * @memberof ProfessionalCategoryDto
     */
    'price': number;
}

export const ProfessionalCategoryDtoNameEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalCategoryDtoNameEnum = typeof ProfessionalCategoryDtoNameEnum[keyof typeof ProfessionalCategoryDtoNameEnum];

/**
 *
 * @export
 * @interface ProfessionalSlotsRequestDto
 */
export interface ProfessionalSlotsRequestDto {
    /**
     *
     * @type {string}
     * @memberof ProfessionalSlotsRequestDto
     */
    'professionalId': string;
    /**
     *
     * @type {number}
     * @memberof ProfessionalSlotsRequestDto
     */
    'durationMinutes': number;
}
/**
 *
 * @export
 * @interface ProfessionalSlotsResponseDto
 */
export interface ProfessionalSlotsResponseDto {
    /**
     * ID of the professional
     * @type {string}
     * @memberof ProfessionalSlotsResponseDto
     */
    'professionalId': string;
    /**
     * Visit category
     * @type {string}
     * @memberof ProfessionalSlotsResponseDto
     */
    'category': ProfessionalSlotsResponseDtoCategoryEnum;
    /**
     * Maximum number of slots per day (if specified)
     * @type {number}
     * @memberof ProfessionalSlotsResponseDto
     */
    'slotsPerDay'?: number;
    /**
     * Total number of available slots found
     * @type {number}
     * @memberof ProfessionalSlotsResponseDto
     */
    'totalSlots': number;
    /**
     * Array of available slot dates and times
     * @type {Array<string>}
     * @memberof ProfessionalSlotsResponseDto
     */
    'slots': Array<string>;
}

export const ProfessionalSlotsResponseDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalSlotsResponseDtoCategoryEnum = typeof ProfessionalSlotsResponseDtoCategoryEnum[keyof typeof ProfessionalSlotsResponseDtoCategoryEnum];

/**
 *
 * @export
 * @interface ProfessionalSlotsResultDto
 */
export interface ProfessionalSlotsResultDto {
    /**
     *
     * @type {string}
     * @memberof ProfessionalSlotsResultDto
     */
    'professionalId': string;
    /**
     *
     * @type {number}
     * @memberof ProfessionalSlotsResultDto
     */
    'totalSlots': number;
    /**
     *
     * @type {Array<string>}
     * @memberof ProfessionalSlotsResultDto
     */
    'slots': Array<string>;
}
/**
 *
 * @export
 * @interface ProfessionalSpecializationDto
 */
export interface ProfessionalSpecializationDto {
    /**
     * Specialization ID
     * @type {string}
     * @memberof ProfessionalSpecializationDto
     */
    'id': string;
    /**
     * Specialization name
     * @type {string}
     * @memberof ProfessionalSpecializationDto
     */
    'name': string;
}
/**
 *
 * @export
 * @interface ProfessionalsSlotsResponseDto
 */
export interface ProfessionalsSlotsResponseDto {
    /**
     *
     * @type {string}
     * @memberof ProfessionalsSlotsResponseDto
     */
    'category': ProfessionalsSlotsResponseDtoCategoryEnum;
    /**
     *
     * @type {Array<ProfessionalSlotsResultDto>}
     * @memberof ProfessionalsSlotsResponseDto
     */
    'professionals': Array<ProfessionalSlotsResultDto>;
}

export const ProfessionalsSlotsResponseDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ProfessionalsSlotsResponseDtoCategoryEnum = typeof ProfessionalsSlotsResponseDtoCategoryEnum[keyof typeof ProfessionalsSlotsResponseDtoCategoryEnum];

/**
 *
 * @export
 * @interface PublicDocumentFileDto
 */
export interface PublicDocumentFileDto {
    /**
     * Proof returned by the upload endpoint for attaching a new file
     * @type {string}
     * @memberof PublicDocumentFileDto
     */
    'uploadToken'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicDocumentFileDto
     */
    'filename': string;
    /**
     *
     * @type {string}
     * @memberof PublicDocumentFileDto
     */
    'url': string;
    /**
     *
     * @type {string}
     * @memberof PublicDocumentFileDto
     */
    'originalFilename'?: string;
}
/**
 *
 * @export
 * @interface PublicExternalIdDto
 */
export interface PublicExternalIdDto {
    /**
     *
     * @type {string}
     * @memberof PublicExternalIdDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof PublicExternalIdDto
     */
    'value': string;
}
/**
 *
 * @export
 * @interface PublicScheduleVisitDto
 */
export interface PublicScheduleVisitDto {
    /**
     * When true, the server creates a real (non-temporary) account for the booker and returns a Firebase custom token in the response. When false, the visit is stored as a guest booking with no user/profile created.
     * @type {boolean}
     * @memberof PublicScheduleVisitDto
     */
    'createAccount': boolean;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'startTime': string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'category': PublicScheduleVisitDtoCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'visitType'?: PublicScheduleVisitDtoVisitTypeEnum;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'description': string;
    /**
     *
     * @type {Array<PublicDocumentFileDto>}
     * @memberof PublicScheduleVisitDto
     */
    'documents'?: Array<PublicDocumentFileDto>;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'promoCode'?: string;
    /**
     *
     * @type {PublicExternalIdDto}
     * @memberof PublicScheduleVisitDto
     */
    'externalId'?: PublicExternalIdDto;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'firstName': string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'lastName': string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'phoneNumber'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'email'?: string;
    /**
     *
     * @type {boolean}
     * @memberof PublicScheduleVisitDto
     */
    'marketing'?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PublicScheduleVisitDto
     */
    'terms': boolean;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'profileName': string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'dob'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'breed'?: string;
    /**
     *
     * @type {number}
     * @memberof PublicScheduleVisitDto
     */
    'weight'?: number;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'gender'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'petCategory'?: PublicScheduleVisitDtoPetCategoryEnum;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'professionalId'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'organizationId'?: string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitDto
     */
    'serviceId'?: string;
    /**
     *
     * @type {PublicVisitAddressDto}
     * @memberof PublicScheduleVisitDto
     */
    'visitAddress'?: PublicVisitAddressDto;
    /**
     *
     * @type {Array<GuestAttachmentClaimDto>}
     * @memberof PublicScheduleVisitDto
     */
    'attachments'?: Array<GuestAttachmentClaimDto>;
}

export const PublicScheduleVisitDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type PublicScheduleVisitDtoCategoryEnum = typeof PublicScheduleVisitDtoCategoryEnum[keyof typeof PublicScheduleVisitDtoCategoryEnum];
export const PublicScheduleVisitDtoVisitTypeEnum = {
    Onsite: 'onsite',
    Mobile: 'mobile',
    Video: 'video',
    Chat: 'chat'
} as const;

export type PublicScheduleVisitDtoVisitTypeEnum = typeof PublicScheduleVisitDtoVisitTypeEnum[keyof typeof PublicScheduleVisitDtoVisitTypeEnum];
export const PublicScheduleVisitDtoPetCategoryEnum = {
    Dog: 'dog',
    Cat: 'cat',
    Other: 'other'
} as const;

export type PublicScheduleVisitDtoPetCategoryEnum = typeof PublicScheduleVisitDtoPetCategoryEnum[keyof typeof PublicScheduleVisitDtoPetCategoryEnum];

/**
 *
 * @export
 * @interface PublicScheduleVisitResponseDto
 */
export interface PublicScheduleVisitResponseDto {
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitResponseDto
     */
    'visitId': string;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitResponseDto
     */
    'paymentUrl': string | null;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitResponseDto
     */
    'customToken'?: string | null;
    /**
     *
     * @type {string}
     * @memberof PublicScheduleVisitResponseDto
     */
    'guestAccessToken'?: string | null;
    /**
     *
     * @type {number}
     * @memberof PublicScheduleVisitResponseDto
     */
    'amount': number;
    /**
     * The visit was created, but one or more booking attachments could not be linked.
     * @type {boolean}
     * @memberof PublicScheduleVisitResponseDto
     */
    'attachmentWarning'?: boolean;
}
/**
 *
 * @export
 * @interface PublicVisitAddressDto
 */
export interface PublicVisitAddressDto {
    /**
     *
     * @type {string}
     * @memberof PublicVisitAddressDto
     */
    'street': string;
    /**
     *
     * @type {string}
     * @memberof PublicVisitAddressDto
     */
    'city': string;
    /**
     *
     * @type {string}
     * @memberof PublicVisitAddressDto
     */
    'zipCode': string;
    /**
     *
     * @type {string}
     * @memberof PublicVisitAddressDto
     */
    'notes'?: string;
}
/**
 *
 * @export
 * @interface PublicWebinarDto
 */
export interface PublicWebinarDto {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'id': string;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'slug': string;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'description': string;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'startsAt': string;
    /**
     * Najwcześniejszy termin ręcznego otwarcia pokoju na żywo. Dołączenie wymaga otwartego pokoju.
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'joinOpensAt'?: string;
    /**
     *
     * @type {number}
     * @memberof PublicWebinarDto
     */
    'durationMinutes': number;
    /**
     *
     * @type {number}
     * @memberof PublicWebinarDto
     */
    'capacity': number;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'status': string;
    /**
     *
     * @type {number}
     * @memberof PublicWebinarDto
     */
    'remainingSeats': number;
    /**
     *
     * @type {boolean}
     * @memberof PublicWebinarDto
     */
    'registrationOpen': boolean;
    /**
     *
     * @type {number}
     * @memberof PublicWebinarDto
     */
    'recordingOnlyRegistrations': number;
    /**
     *
     * @type {boolean}
     * @memberof PublicWebinarDto
     */
    'recordingRegistrationOpen': boolean;
    /**
     *
     * @type {string}
     * @memberof PublicWebinarDto
     */
    'recordingNotice': string;
}
/**
 *
 * @export
 * @interface ServiceConfigDto
 */
export interface ServiceConfigDto {
    /**
     * Derived from the service: onsite/mobile without prepayment use AT_FACILITY; positive prepayment and online visits use ONLINE_REQUIRED.
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'paymentTiming': string | null;
    /**
     * Service ID
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'serviceId': string;
    /**
     * Service name
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'serviceName': string;
    /**
     * Specialization ID this service is assigned to
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'specializationId': string;
    /**
     * Service category
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'category': ServiceConfigDtoCategoryEnum;
    /**
     * Visit type for this service
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'visitType': ServiceConfigDtoVisitTypeEnum;
    /**
     * Service duration in minutes
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'duration': number;
    /**
     * Default price for this service in PLN
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'defaultPrice': number;
    /**
     * Notes about this service
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'notes'?: string;
    /**
     * Description of the service
     * @type {string}
     * @memberof ServiceConfigDto
     */
    'description'?: string;
    /**
     * Reservation fee in PLN charged at booking. null = no fee.
     * @type {number}
     * @memberof ServiceConfigDto
     */
    'prepaidAmount'?: number;
}

export const ServiceConfigDtoCategoryEnum = {
    Veterinarian: 'veterinarian',
    Dietitian: 'dietitian',
    Behaviorist: 'behaviorist',
    Physiotherapist: 'physiotherapist'
} as const;

export type ServiceConfigDtoCategoryEnum = typeof ServiceConfigDtoCategoryEnum[keyof typeof ServiceConfigDtoCategoryEnum];
export const ServiceConfigDtoVisitTypeEnum = {
    Video: 'video',
    Chat: 'chat',
    Onsite: 'onsite',
    Mobile: 'mobile'
} as const;

export type ServiceConfigDtoVisitTypeEnum = typeof ServiceConfigDtoVisitTypeEnum[keyof typeof ServiceConfigDtoVisitTypeEnum];

/**
 *
 * @export
 * @interface StartVoiceDsrDto
 */
export interface StartVoiceDsrDto {
    /**
     *
     * @type {string}
     * @memberof StartVoiceDsrDto
     */
    'right': StartVoiceDsrDtoRightEnum;
    /**
     *
     * @type {string}
     * @memberof StartVoiceDsrDto
     */
    'channel': StartVoiceDsrDtoChannelEnum;
    /**
     * Numer E.164 do weryfikacji SMS
     * @type {string}
     * @memberof StartVoiceDsrDto
     */
    'contact': string;
}

export const StartVoiceDsrDtoRightEnum = {
    Access: 'ACCESS',
    Correction: 'CORRECTION',
    Restriction: 'RESTRICTION',
    Erasure: 'ERASURE'
} as const;

export type StartVoiceDsrDtoRightEnum = typeof StartVoiceDsrDtoRightEnum[keyof typeof StartVoiceDsrDtoRightEnum];
export const StartVoiceDsrDtoChannelEnum = {
    Sms: 'SMS'
} as const;

export type StartVoiceDsrDtoChannelEnum = typeof StartVoiceDsrDtoChannelEnum[keyof typeof StartVoiceDsrDtoChannelEnum];

/**
 *
 * @export
 * @interface TimeOffDto
 */
export interface TimeOffDto {
    /**
     * Start date of time off (ISO string)
     * @type {string}
     * @memberof TimeOffDto
     */
    'startDate': string;
    /**
     * End date of time off (ISO string)
     * @type {string}
     * @memberof TimeOffDto
     */
    'endDate': string;
    /**
     * Start time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof TimeOffDto
     */
    'startTime'?: string;
    /**
     * End time in HH:MM format for time-specific unavailability
     * @type {string}
     * @memberof TimeOffDto
     */
    'endTime'?: string;
}
/**
 *
 * @export
 * @interface ValidatePromoCodeDto
 */
export interface ValidatePromoCodeDto {
    /**
     * Promo code to validate
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'code': string;
    /**
     * Category for which the promo code is being validated (required for visit type)
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'category'?: string;
    /**
     * Promo code type
     * @type {string}
     * @memberof ValidatePromoCodeDto
     */
    'type'?: ValidatePromoCodeDtoTypeEnum;
}

export const ValidatePromoCodeDtoTypeEnum = {
    Visit: 'visit',
    Campaign: 'campaign'
} as const;

export type ValidatePromoCodeDtoTypeEnum = typeof ValidatePromoCodeDtoTypeEnum[keyof typeof ValidatePromoCodeDtoTypeEnum];

/**
 *
 * @export
 * @interface ValidatePromoCodeResponseDto
 */
export interface ValidatePromoCodeResponseDto {
    /**
     * Discount percentage
     * @type {number}
     * @memberof ValidatePromoCodeResponseDto
     */
    'discountPercentage': number;
    /**
     * Discounted price (if applicable)
     * @type {number}
     * @memberof ValidatePromoCodeResponseDto
     */
    'discountedPrice'?: number;
}
/**
 *
 * @export
 * @interface VerifyVoiceDsrDto
 */
export interface VerifyVoiceDsrDto {
    /**
     *
     * @type {string}
     * @memberof VerifyVoiceDsrDto
     */
    'code': string;
}
/**
 *
 * @export
 * @interface VetReferralDto
 */
export interface VetReferralDto {
    /**
     * Name of the clinic or veterinary practice
     * @type {string}
     * @memberof VetReferralDto
     */
    'clinicName': string;
    /**
     * City where the clinic is located
     * @type {string}
     * @memberof VetReferralDto
     */
    'city': string;
    /**
     * Name of the veterinarian (optional)
     * @type {string}
     * @memberof VetReferralDto
     */
    'doctorName'?: string;
    /**
     * User accepts the privacy policy
     * @type {boolean}
     * @memberof VetReferralDto
     */
    'acceptsPrivacy': boolean;
}
/**
 *
 * @export
 * @interface VisitGuestAttachmentControllerGetSignedUrl200Response
 */
export interface VisitGuestAttachmentControllerGetSignedUrl200Response {
    /**
     *
     * @type {string}
     * @memberof VisitGuestAttachmentControllerGetSignedUrl200Response
     */
    'url'?: string;
}
/**
 *
 * @export
 * @interface VisitGuestAttachmentControllerUploadVisitPrivate201Response
 */
export interface VisitGuestAttachmentControllerUploadVisitPrivate201Response {
    /**
     *
     * @type {string}
     * @memberof VisitGuestAttachmentControllerUploadVisitPrivate201Response
     */
    'filename'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitGuestAttachmentControllerUploadVisitPrivate201Response
     */
    'url'?: string;
    /**
     *
     * @type {string}
     * @memberof VisitGuestAttachmentControllerUploadVisitPrivate201Response
     */
    'uploadToken'?: string;
}
/**
 *
 * @export
 * @interface VoiceDevelopOperatorTrialNoticeDto
 */
export interface VoiceDevelopOperatorTrialNoticeDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'runtimeProfile': VoiceDevelopOperatorTrialNoticeDtoRuntimeProfileEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'googleRetention': VoiceDevelopOperatorTrialNoticeDtoGoogleRetentionEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'legalApproval': VoiceDevelopOperatorTrialNoticeDtoLegalApprovalEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'status': VoiceDevelopOperatorTrialNoticeDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'version': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'contentSha256': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'issuedAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'monitoringExpiresAt': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'observedAt': string;
    /**
     *
     * @type {VoicePrivacyControllerDto}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'controller': VoicePrivacyControllerDto;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'sections': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'rights': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeDto
     */
    'rightsContactUrl'?: string | null;
}

export const VoiceDevelopOperatorTrialNoticeDtoRuntimeProfileEnum = {
    DevelopOperatorTrial: 'DEVELOP_OPERATOR_TRIAL'
} as const;

export type VoiceDevelopOperatorTrialNoticeDtoRuntimeProfileEnum = typeof VoiceDevelopOperatorTrialNoticeDtoRuntimeProfileEnum[keyof typeof VoiceDevelopOperatorTrialNoticeDtoRuntimeProfileEnum];
export const VoiceDevelopOperatorTrialNoticeDtoGoogleRetentionEnum = {
    Unverified: 'UNVERIFIED'
} as const;

export type VoiceDevelopOperatorTrialNoticeDtoGoogleRetentionEnum = typeof VoiceDevelopOperatorTrialNoticeDtoGoogleRetentionEnum[keyof typeof VoiceDevelopOperatorTrialNoticeDtoGoogleRetentionEnum];
export const VoiceDevelopOperatorTrialNoticeDtoLegalApprovalEnum = {
    Unverified: 'UNVERIFIED'
} as const;

export type VoiceDevelopOperatorTrialNoticeDtoLegalApprovalEnum = typeof VoiceDevelopOperatorTrialNoticeDtoLegalApprovalEnum[keyof typeof VoiceDevelopOperatorTrialNoticeDtoLegalApprovalEnum];
export const VoiceDevelopOperatorTrialNoticeDtoStatusEnum = {
    Active: 'ACTIVE',
    MonitoringRequired: 'MONITORING_REQUIRED'
} as const;

export type VoiceDevelopOperatorTrialNoticeDtoStatusEnum = typeof VoiceDevelopOperatorTrialNoticeDtoStatusEnum[keyof typeof VoiceDevelopOperatorTrialNoticeDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceDsrStartResponseDto
 */
export interface VoiceDsrStartResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStartResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStartResponseDto
     */
    'challengeExpiresAt': string;
}
/**
 *
 * @export
 * @interface VoiceDsrStatusQueryDto
 */
export interface VoiceDsrStatusQueryDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusQueryDto
     */
    'token': string;
}
/**
 *
 * @export
 * @interface VoiceDsrStatusResponseDto
 */
export interface VoiceDsrStatusResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'right': VoiceDsrStatusResponseDtoRightEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'status': VoiceDsrStatusResponseDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'temporaryHoldUntil'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'completedAt'?: string | null;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrStatusResponseDto
     */
    'safeReasonCode'?: string | null;
}

export const VoiceDsrStatusResponseDtoRightEnum = {
    Access: 'ACCESS',
    Correction: 'CORRECTION',
    Restriction: 'RESTRICTION',
    Erasure: 'ERASURE'
} as const;

export type VoiceDsrStatusResponseDtoRightEnum = typeof VoiceDsrStatusResponseDtoRightEnum[keyof typeof VoiceDsrStatusResponseDtoRightEnum];
export const VoiceDsrStatusResponseDtoStatusEnum = {
    AwaitingOtp: 'AWAITING_OTP',
    PendingHumanReview: 'PENDING_HUMAN_REVIEW',
    InReview: 'IN_REVIEW',
    Restricted: 'RESTRICTED',
    DeferredByLegalHold: 'DEFERRED_BY_LEGAL_HOLD',
    Completed: 'COMPLETED',
    Rejected: 'REJECTED'
} as const;

export type VoiceDsrStatusResponseDtoStatusEnum = typeof VoiceDsrStatusResponseDtoStatusEnum[keyof typeof VoiceDsrStatusResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoiceDsrVerifiedResponseDto
 */
export interface VoiceDsrVerifiedResponseDto {
    /**
     *
     * @type {string}
     * @memberof VoiceDsrVerifiedResponseDto
     */
    'requestId': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrVerifiedResponseDto
     */
    'right': VoiceDsrVerifiedResponseDtoRightEnum;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrVerifiedResponseDto
     */
    'status': VoiceDsrVerifiedResponseDtoStatusEnum;
    /**
     * Oddzielny, ograniczony token odczytu statusu
     * @type {string}
     * @memberof VoiceDsrVerifiedResponseDto
     */
    'statusToken': string;
    /**
     *
     * @type {string}
     * @memberof VoiceDsrVerifiedResponseDto
     */
    'temporaryHoldUntil'?: string | null;
}

export const VoiceDsrVerifiedResponseDtoRightEnum = {
    Access: 'ACCESS',
    Correction: 'CORRECTION',
    Restriction: 'RESTRICTION',
    Erasure: 'ERASURE'
} as const;

export type VoiceDsrVerifiedResponseDtoRightEnum = typeof VoiceDsrVerifiedResponseDtoRightEnum[keyof typeof VoiceDsrVerifiedResponseDtoRightEnum];
export const VoiceDsrVerifiedResponseDtoStatusEnum = {
    PendingHumanReview: 'PENDING_HUMAN_REVIEW'
} as const;

export type VoiceDsrVerifiedResponseDtoStatusEnum = typeof VoiceDsrVerifiedResponseDtoStatusEnum[keyof typeof VoiceDsrVerifiedResponseDtoStatusEnum];

/**
 *
 * @export
 * @interface VoicePrivacyControllerDto
 */
export interface VoicePrivacyControllerDto {
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyControllerDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyControllerDto
     */
    'address': string;
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyControllerDto
     */
    'email'?: string | null;
}
/**
 *
 * @export
 * @interface VoicePrivacyNoticeDto
 */
export interface VoicePrivacyNoticeDto {
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyNoticeDto
     */
    'version': string;
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyNoticeDto
     */
    'effectiveFrom': string;
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyNoticeDto
     */
    'title': string;
    /**
     *
     * @type {VoicePrivacyControllerDto}
     * @memberof VoicePrivacyNoticeDto
     */
    'controller': VoicePrivacyControllerDto;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePrivacyNoticeDto
     */
    'sections': Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof VoicePrivacyNoticeDto
     */
    'rights': Array<string>;
    /**
     *
     * @type {string}
     * @memberof VoicePrivacyNoticeDto
     */
    'dataSubjectRequestUrl': string;
}
/**
 *
 * @export
 * @interface WebinarAdmissionDto
 */
export interface WebinarAdmissionDto {
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionDto
     */
    'registrationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionDto
     */
    'secret': string;
}
/**
 *
 * @export
 * @interface WebinarAdmissionResultDto
 */
export interface WebinarAdmissionResultDto {
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionResultDto
     */
    'status': WebinarAdmissionResultDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionResultDto
     */
    'clientUrl'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarAdmissionResultDto
     */
    'token'?: string;
}

export const WebinarAdmissionResultDtoStatusEnum = {
    Waiting: 'waiting',
    Ready: 'ready'
} as const;

export type WebinarAdmissionResultDtoStatusEnum = typeof WebinarAdmissionResultDtoStatusEnum[keyof typeof WebinarAdmissionResultDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarAttributionConsentDto
 */
export interface WebinarAttributionConsentDto {
    /**
     *
     * @type {string}
     * @memberof WebinarAttributionConsentDto
     */
    'version': WebinarAttributionConsentDtoVersionEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarAttributionConsentDto
     */
    'grantedAt': string;
}

export const WebinarAttributionConsentDtoVersionEnum = {
    WebinarAttributionV1: 'webinar-attribution-v1'
} as const;

export type WebinarAttributionConsentDtoVersionEnum = typeof WebinarAttributionConsentDtoVersionEnum[keyof typeof WebinarAttributionConsentDtoVersionEnum];

/**
 *
 * @export
 * @interface WebinarAttributionDto
 */
export interface WebinarAttributionDto {
    /**
     * utm_source
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'source': string;
    /**
     * utm_medium
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'medium'?: string;
    /**
     * utm_campaign
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'campaign'?: string;
    /**
     * utm_content
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'content'?: string;
    /**
     * utm_term
     * @type {string}
     * @memberof WebinarAttributionDto
     */
    'term'?: string;
}
/**
 *
 * @export
 * @interface WebinarConfirmDto
 */
export interface WebinarConfirmDto {
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmDto
     */
    'registrationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmDto
     */
    'secret': string;
}
/**
 *
 * @export
 * @interface WebinarConfirmationResultDto
 */
export interface WebinarConfirmationResultDto {
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationResultDto
     */
    'status': WebinarConfirmationResultDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationResultDto
     */
    'mode': WebinarConfirmationResultDtoModeEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationResultDto
     */
    'requestedMode': WebinarConfirmationResultDtoRequestedModeEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarConfirmationResultDto
     */
    'fallbackReason'?: WebinarConfirmationResultDtoFallbackReasonEnum;
    /**
     * Prawda tylko dla żądania, które zmieniło zgłoszenie z oczekującego na potwierdzone.
     * @type {boolean}
     * @memberof WebinarConfirmationResultDto
     */
    'newlyConfirmed': boolean;
}

export const WebinarConfirmationResultDtoStatusEnum = {
    Confirmed: 'confirmed'
} as const;

export type WebinarConfirmationResultDtoStatusEnum = typeof WebinarConfirmationResultDtoStatusEnum[keyof typeof WebinarConfirmationResultDtoStatusEnum];
export const WebinarConfirmationResultDtoModeEnum = {
    Live: 'live',
    Recording: 'recording'
} as const;

export type WebinarConfirmationResultDtoModeEnum = typeof WebinarConfirmationResultDtoModeEnum[keyof typeof WebinarConfirmationResultDtoModeEnum];
export const WebinarConfirmationResultDtoRequestedModeEnum = {
    Live: 'live',
    Recording: 'recording'
} as const;

export type WebinarConfirmationResultDtoRequestedModeEnum = typeof WebinarConfirmationResultDtoRequestedModeEnum[keyof typeof WebinarConfirmationResultDtoRequestedModeEnum];
export const WebinarConfirmationResultDtoFallbackReasonEnum = {
    Full: 'LIVE_FULL',
    Closed: 'LIVE_CLOSED'
} as const;

export type WebinarConfirmationResultDtoFallbackReasonEnum = typeof WebinarConfirmationResultDtoFallbackReasonEnum[keyof typeof WebinarConfirmationResultDtoFallbackReasonEnum];

/**
 *
 * @export
 * @interface WebinarRegistrationDto
 */
export interface WebinarRegistrationDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationDto
     */
    'mode'?: WebinarRegistrationDtoModeEnum;
    /**
     *
     * @type {boolean}
     * @memberof WebinarRegistrationDto
     */
    'marketingConsent'?: boolean;
    /**
     * Opcjonalne potwierdzenie informacji o nagrywaniu zachowane dla zgodności ze starszym formularzem.
     * @type {boolean}
     * @memberof WebinarRegistrationDto
     */
    'recordingConsent'?: boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationDto
     */
    'email': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationDto
     */
    'profession'?: string;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationDto
     */
    'clinic'?: string;
    /**
     *
     * @type {WebinarAttributionDto}
     * @memberof WebinarRegistrationDto
     */
    'attribution'?: WebinarAttributionDto;
    /**
     *
     * @type {WebinarAttributionConsentDto}
     * @memberof WebinarRegistrationDto
     */
    'attributionConsent'?: WebinarAttributionConsentDto;
}

export const WebinarRegistrationDtoModeEnum = {
    Live: 'live',
    Recording: 'recording'
} as const;

export type WebinarRegistrationDtoModeEnum = typeof WebinarRegistrationDtoModeEnum[keyof typeof WebinarRegistrationDtoModeEnum];

/**
 *
 * @export
 * @interface WebinarRegistrationResultDto
 */
export interface WebinarRegistrationResultDto {
    /**
     *
     * @type {boolean}
     * @memberof WebinarRegistrationResultDto
     */
    'accepted': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarRegistrationResultDto
     */
    'message': string;
}
/**
 *
 * @export
 * @interface WebinarRehearsalAccessDto
 */
export interface WebinarRehearsalAccessDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalAccessDto
     */
    'invitationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalAccessDto
     */
    'secret': string;
}
/**
 *
 * @export
 * @interface WebinarRehearsalJoinDto
 */
export interface WebinarRehearsalJoinDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalJoinDto
     */
    'invitationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalJoinDto
     */
    'secret': string;
    /**
     *
     * @type {number}
     * @memberof WebinarRehearsalJoinDto
     */
    'recordingConsent': WebinarRehearsalJoinDtoRecordingConsentEnum;
}

export const WebinarRehearsalJoinDtoRecordingConsentEnum = {
    NUMBER_null: null
} as const;

export type WebinarRehearsalJoinDtoRecordingConsentEnum = typeof WebinarRehearsalJoinDtoRecordingConsentEnum[keyof typeof WebinarRehearsalJoinDtoRecordingConsentEnum];

/**
 *
 * @export
 * @interface WebinarRehearsalPreviewDto
 */
export interface WebinarRehearsalPreviewDto {
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalPreviewDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalPreviewDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalPreviewDto
     */
    'role': WebinarRehearsalPreviewDtoRoleEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalPreviewDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarRehearsalPreviewDto
     */
    'recordingNotice': string;
}

export const WebinarRehearsalPreviewDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator',
    Attendee: 'attendee'
} as const;

export type WebinarRehearsalPreviewDtoRoleEnum = typeof WebinarRehearsalPreviewDtoRoleEnum[keyof typeof WebinarRehearsalPreviewDtoRoleEnum];

/**
 *
 * @export
 * @interface WebinarStaffAccessDto
 */
export interface WebinarStaffAccessDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffAccessDto
     */
    'invitationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffAccessDto
     */
    'secret': string;
}
/**
 *
 * @export
 * @interface WebinarStaffJoinDto
 */
export interface WebinarStaffJoinDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffJoinDto
     */
    'invitationId': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffJoinDto
     */
    'secret': string;
    /**
     *
     * @type {number}
     * @memberof WebinarStaffJoinDto
     */
    'recordingConsent': WebinarStaffJoinDtoRecordingConsentEnum;
    /**
     * Whether the accepted recording notice was for a rehearsal; a different current room answers waiting.
     * @type {boolean}
     * @memberof WebinarStaffJoinDto
     */
    'rehearsal'?: boolean;
}

export const WebinarStaffJoinDtoRecordingConsentEnum = {
    NUMBER_null: null
} as const;

export type WebinarStaffJoinDtoRecordingConsentEnum = typeof WebinarStaffJoinDtoRecordingConsentEnum[keyof typeof WebinarStaffJoinDtoRecordingConsentEnum];

/**
 *
 * @export
 * @interface WebinarStaffPreviewDto
 */
export interface WebinarStaffPreviewDto {
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'crewOpensAt': string;
    /**
     *
     * @type {boolean}
     * @memberof WebinarStaffPreviewDto
     */
    'preparation': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'title': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'name': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'role': WebinarStaffPreviewDtoRoleEnum;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'startsAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'joinOpensAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'expiresAt': string;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'recordingNotice': string;
    /**
     * True while the link admits to the running rehearsal instead of the live webinar.
     * @type {boolean}
     * @memberof WebinarStaffPreviewDto
     */
    'rehearsal': boolean;
    /**
     *
     * @type {string}
     * @memberof WebinarStaffPreviewDto
     */
    'status': WebinarStaffPreviewDtoStatusEnum;
}

export const WebinarStaffPreviewDtoRoleEnum = {
    Host: 'host',
    Guest: 'guest',
    Moderator: 'moderator'
} as const;

export type WebinarStaffPreviewDtoRoleEnum = typeof WebinarStaffPreviewDtoRoleEnum[keyof typeof WebinarStaffPreviewDtoRoleEnum];
export const WebinarStaffPreviewDtoStatusEnum = {
    Waiting: 'waiting',
    Ready: 'ready',
    Ended: 'ended'
} as const;

export type WebinarStaffPreviewDtoStatusEnum = typeof WebinarStaffPreviewDtoStatusEnum[keyof typeof WebinarStaffPreviewDtoStatusEnum];

/**
 *
 * @export
 * @interface WebinarVerificationResendDto
 */
export interface WebinarVerificationResendDto {
    /**
     *
     * @type {string}
     * @memberof WebinarVerificationResendDto
     */
    'email': string;
}

/**
 * ClinicWebsiteApi - axios parameter creator
 * @export
 */
export const ClinicWebsiteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit a contact form from a clinic website. Rate limited to 3 requests per minute.
         * @summary Send clinic contact form
         * @param {ClinicContactDto} clinicContactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clinicWebsiteControllerSubmitContactForm: async (clinicContactDto: ClinicContactDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clinicContactDto' is not null or undefined
            assertParamExists('clinicWebsiteControllerSubmitContactForm', 'clinicContactDto', clinicContactDto)
            const localVarPath = `/public/clinic-website/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clinicContactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicWebsiteApi - functional programming interface
 * @export
 */
export const ClinicWebsiteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicWebsiteApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit a contact form from a clinic website. Rate limited to 3 requests per minute.
         * @summary Send clinic contact form
         * @param {ClinicContactDto} clinicContactDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clinicWebsiteControllerSubmitContactForm(clinicContactDto: ClinicContactDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clinicWebsiteControllerSubmitContactForm(clinicContactDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClinicWebsiteApi - factory interface
 * @export
 */
export const ClinicWebsiteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicWebsiteApiFp(configuration)
    return {
        /**
         * Submit a contact form from a clinic website. Rate limited to 3 requests per minute.
         * @summary Send clinic contact form
         * @param {ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clinicWebsiteControllerSubmitContactForm(requestParameters: ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clinicWebsiteControllerSubmitContactForm(requestParameters.clinicContactDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for clinicWebsiteControllerSubmitContactForm operation in ClinicWebsiteApi.
 * @export
 * @interface ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest
 */
export interface ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest {
    /**
     *
     * @type {ClinicContactDto}
     * @memberof ClinicWebsiteApiClinicWebsiteControllerSubmitContactForm
     */
    readonly clinicContactDto: ClinicContactDto
}

/**
 * ClinicWebsiteApi - object-oriented interface
 * @export
 * @class ClinicWebsiteApi
 * @extends {BaseAPI}
 */
export class ClinicWebsiteApi extends BaseAPI {
    /**
     * Submit a contact form from a clinic website. Rate limited to 3 requests per minute.
     * @summary Send clinic contact form
     * @param {ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicWebsiteApi
     */
    public clinicWebsiteControllerSubmitContactForm(requestParameters: ClinicWebsiteApiClinicWebsiteControllerSubmitContactFormRequest, options?: AxiosRequestConfig) {
        return ClinicWebsiteApiFp(this.configuration).clinicWebsiteControllerSubmitContactForm(requestParameters.clinicContactDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productionCandidateHealthControllerHealth: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/internal/production-candidate/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productionCandidateHealthControllerHealth(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productionCandidateHealthControllerHealth(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productionCandidateHealthControllerHealth(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.productionCandidateHealthControllerHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public productionCandidateHealthControllerHealth(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).productionCandidateHealthControllerHealth(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationPublicApi - axios parameter creator
 * @export
 */
export const OrganizationPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all unique cities from organizations (public access)
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all cities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetAllCities: async (visitType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/organization/cities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get last booked visit for an organization (public access)
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetLastBookedVisit: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPublicControllerGetLastBookedVisit', 'id', id)
            const localVarPath = `/public/organization/{id}/last-booked-visit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organization by ID (public access)
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizationById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPublicControllerGetOrganizationById', 'id', id)
            const localVarPath = `/public/organization/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get professionals for a specific organization (public access)
         * @param {string} id
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all professionals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizationProfessionals: async (id: string, visitType?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('organizationPublicControllerGetOrganizationProfessionals', 'id', id)
            const localVarPath = `/public/organization/{id}/professionals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get organizations with optional filters (public access)
         * @param {string} [name] Filter by organization name
         * @param {string} [city] Filter by city name
         * @param {string} [specialization] Filter by specialization ID
         * @param {'video' | 'chat' | 'onsite'} [visitType] Filter by visit type
         * @param {string} [category] Filter by visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizations: async (name?: string, city?: string, specialization?: string, visitType?: 'video' | 'chat' | 'onsite', category?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (specialization !== undefined) {
                localVarQueryParameter['specialization'] = specialization;
            }

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationPublicApi - functional programming interface
 * @export
 */
export const OrganizationPublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationPublicApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all unique cities from organizations (public access)
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all cities.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPublicControllerGetAllCities(visitType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetCityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPublicControllerGetAllCities(visitType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get last booked visit for an organization (public access)
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPublicControllerGetLastBookedVisit(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLastBookedVisitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPublicControllerGetLastBookedVisit(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organization by ID (public access)
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPublicControllerGetOrganizationById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrganizationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPublicControllerGetOrganizationById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get professionals for a specific organization (public access)
         * @param {string} id
         * @param {string} [visitType] Optional visit type filter. If not provided, returns all professionals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPublicControllerGetOrganizationProfessionals(id: string, visitType?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationProfessionalsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPublicControllerGetOrganizationProfessionals(id, visitType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get organizations with optional filters (public access)
         * @param {string} [name] Filter by organization name
         * @param {string} [city] Filter by city name
         * @param {string} [specialization] Filter by specialization ID
         * @param {'video' | 'chat' | 'onsite'} [visitType] Filter by visit type
         * @param {string} [category] Filter by visit category ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async organizationPublicControllerGetOrganizations(name?: string, city?: string, specialization?: string, visitType?: 'video' | 'chat' | 'onsite', category?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetOrganizationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.organizationPublicControllerGetOrganizations(name, city, specialization, visitType, category, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationPublicApi - factory interface
 * @export
 */
export const OrganizationPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationPublicApiFp(configuration)
    return {
        /**
         *
         * @summary Get all unique cities from organizations (public access)
         * @param {OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetAllCities(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GetCityDto>> {
            return localVarFp.organizationPublicControllerGetAllCities(requestParameters.visitType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get last booked visit for an organization (public access)
         * @param {OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetLastBookedVisit(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest, options?: AxiosRequestConfig): AxiosPromise<GetLastBookedVisitDto> {
            return localVarFp.organizationPublicControllerGetLastBookedVisit(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organization by ID (public access)
         * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizationById(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest, options?: AxiosRequestConfig): AxiosPromise<GetOrganizationDto> {
            return localVarFp.organizationPublicControllerGetOrganizationById(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get professionals for a specific organization (public access)
         * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizationProfessionals(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationProfessionalsDto>> {
            return localVarFp.organizationPublicControllerGetOrganizationProfessionals(requestParameters.id, requestParameters.visitType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get organizations with optional filters (public access)
         * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        organizationPublicControllerGetOrganizations(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<GetOrganizationDto>> {
            return localVarFp.organizationPublicControllerGetOrganizations(requestParameters.name, requestParameters.city, requestParameters.specialization, requestParameters.visitType, requestParameters.category, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for organizationPublicControllerGetAllCities operation in OrganizationPublicApi.
 * @export
 * @interface OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest
 */
export interface OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest {
    /**
     * Optional visit type filter. If not provided, returns all cities.
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetAllCities
     */
    readonly visitType?: string
}

/**
 * Request parameters for organizationPublicControllerGetLastBookedVisit operation in OrganizationPublicApi.
 * @export
 * @interface OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest
 */
export interface OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisit
     */
    readonly id: string
}

/**
 * Request parameters for organizationPublicControllerGetOrganizationById operation in OrganizationPublicApi.
 * @export
 * @interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest
 */
export interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizationById
     */
    readonly id: string
}

/**
 * Request parameters for organizationPublicControllerGetOrganizationProfessionals operation in OrganizationPublicApi.
 * @export
 * @interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest
 */
export interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest {
    /**
     *
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionals
     */
    readonly id: string

    /**
     * Optional visit type filter. If not provided, returns all professionals.
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionals
     */
    readonly visitType?: string
}

/**
 * Request parameters for organizationPublicControllerGetOrganizations operation in OrganizationPublicApi.
 * @export
 * @interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest
 */
export interface OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest {
    /**
     * Filter by organization name
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizations
     */
    readonly name?: string

    /**
     * Filter by city name
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizations
     */
    readonly city?: string

    /**
     * Filter by specialization ID
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizations
     */
    readonly specialization?: string

    /**
     * Filter by visit type
     * @type {'video' | 'chat' | 'onsite'}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizations
     */
    readonly visitType?: 'video' | 'chat' | 'onsite'

    /**
     * Filter by visit category ID
     * @type {string}
     * @memberof OrganizationPublicApiOrganizationPublicControllerGetOrganizations
     */
    readonly category?: string
}

/**
 * OrganizationPublicApi - object-oriented interface
 * @export
 * @class OrganizationPublicApi
 * @extends {BaseAPI}
 */
export class OrganizationPublicApi extends BaseAPI {
    /**
     *
     * @summary Get all unique cities from organizations (public access)
     * @param {OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPublicApi
     */
    public organizationPublicControllerGetAllCities(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetAllCitiesRequest = {}, options?: AxiosRequestConfig) {
        return OrganizationPublicApiFp(this.configuration).organizationPublicControllerGetAllCities(requestParameters.visitType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get last booked visit for an organization (public access)
     * @param {OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPublicApi
     */
    public organizationPublicControllerGetLastBookedVisit(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetLastBookedVisitRequest, options?: AxiosRequestConfig) {
        return OrganizationPublicApiFp(this.configuration).organizationPublicControllerGetLastBookedVisit(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organization by ID (public access)
     * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPublicApi
     */
    public organizationPublicControllerGetOrganizationById(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationByIdRequest, options?: AxiosRequestConfig) {
        return OrganizationPublicApiFp(this.configuration).organizationPublicControllerGetOrganizationById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get professionals for a specific organization (public access)
     * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPublicApi
     */
    public organizationPublicControllerGetOrganizationProfessionals(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationProfessionalsRequest, options?: AxiosRequestConfig) {
        return OrganizationPublicApiFp(this.configuration).organizationPublicControllerGetOrganizationProfessionals(requestParameters.id, requestParameters.visitType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get organizations with optional filters (public access)
     * @param {OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationPublicApi
     */
    public organizationPublicControllerGetOrganizations(requestParameters: OrganizationPublicApiOrganizationPublicControllerGetOrganizationsRequest = {}, options?: AxiosRequestConfig) {
        return OrganizationPublicApiFp(this.configuration).organizationPublicControllerGetOrganizations(requestParameters.name, requestParameters.city, requestParameters.specialization, requestParameters.visitType, requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductCheckApi - axios parameter creator
 * @export
 */
export const ProductCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Check product suitability for a specific pet breed
         * @param {ProductCheckDto} productCheckDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCheckControllerCheckProduct: async (productCheckDto: ProductCheckDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCheckDto' is not null or undefined
            assertParamExists('productCheckControllerCheckProduct', 'productCheckDto', productCheckDto)
            const localVarPath = `/api/product-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productCheckDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCheckApi - functional programming interface
 * @export
 */
export const ProductCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductCheckApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Check product suitability for a specific pet breed
         * @param {ProductCheckDto} productCheckDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productCheckControllerCheckProduct(productCheckDto: ProductCheckDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductCheckResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productCheckControllerCheckProduct(productCheckDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductCheckApi - factory interface
 * @export
 */
export const ProductCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductCheckApiFp(configuration)
    return {
        /**
         *
         * @summary Check product suitability for a specific pet breed
         * @param {ProductCheckApiProductCheckControllerCheckProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productCheckControllerCheckProduct(requestParameters: ProductCheckApiProductCheckControllerCheckProductRequest, options?: AxiosRequestConfig): AxiosPromise<ProductCheckResponseDto> {
            return localVarFp.productCheckControllerCheckProduct(requestParameters.productCheckDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for productCheckControllerCheckProduct operation in ProductCheckApi.
 * @export
 * @interface ProductCheckApiProductCheckControllerCheckProductRequest
 */
export interface ProductCheckApiProductCheckControllerCheckProductRequest {
    /**
     *
     * @type {ProductCheckDto}
     * @memberof ProductCheckApiProductCheckControllerCheckProduct
     */
    readonly productCheckDto: ProductCheckDto
}

/**
 * ProductCheckApi - object-oriented interface
 * @export
 * @class ProductCheckApi
 * @extends {BaseAPI}
 */
export class ProductCheckApi extends BaseAPI {
    /**
     *
     * @summary Check product suitability for a specific pet breed
     * @param {ProductCheckApiProductCheckControllerCheckProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCheckApi
     */
    public productCheckControllerCheckProduct(requestParameters: ProductCheckApiProductCheckControllerCheckProductRequest, options?: AxiosRequestConfig) {
        return ProductCheckApiFp(this.configuration).productCheckControllerCheckProduct(requestParameters.productCheckDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PromoCodePublicApi - axios parameter creator
 * @export
 */
export const PromoCodePublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Validate promo code (public access)
         * @param {ValidatePromoCodeDto} validatePromoCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodePublicControllerVerifyPromoCode: async (validatePromoCodeDto: ValidatePromoCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validatePromoCodeDto' is not null or undefined
            assertParamExists('promoCodePublicControllerVerifyPromoCode', 'validatePromoCodeDto', validatePromoCodeDto)
            const localVarPath = `/public/promocode/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validatePromoCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromoCodePublicApi - functional programming interface
 * @export
 */
export const PromoCodePublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromoCodePublicApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Validate promo code (public access)
         * @param {ValidatePromoCodeDto} validatePromoCodeDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async promoCodePublicControllerVerifyPromoCode(validatePromoCodeDto: ValidatePromoCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidatePromoCodeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.promoCodePublicControllerVerifyPromoCode(validatePromoCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromoCodePublicApi - factory interface
 * @export
 */
export const PromoCodePublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromoCodePublicApiFp(configuration)
    return {
        /**
         *
         * @summary Validate promo code (public access)
         * @param {PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        promoCodePublicControllerVerifyPromoCode(requestParameters: PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest, options?: AxiosRequestConfig): AxiosPromise<ValidatePromoCodeResponseDto> {
            return localVarFp.promoCodePublicControllerVerifyPromoCode(requestParameters.validatePromoCodeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for promoCodePublicControllerVerifyPromoCode operation in PromoCodePublicApi.
 * @export
 * @interface PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest
 */
export interface PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest {
    /**
     *
     * @type {ValidatePromoCodeDto}
     * @memberof PromoCodePublicApiPromoCodePublicControllerVerifyPromoCode
     */
    readonly validatePromoCodeDto: ValidatePromoCodeDto
}

/**
 * PromoCodePublicApi - object-oriented interface
 * @export
 * @class PromoCodePublicApi
 * @extends {BaseAPI}
 */
export class PromoCodePublicApi extends BaseAPI {
    /**
     *
     * @summary Validate promo code (public access)
     * @param {PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromoCodePublicApi
     */
    public promoCodePublicControllerVerifyPromoCode(requestParameters: PromoCodePublicApiPromoCodePublicControllerVerifyPromoCodeRequest, options?: AxiosRequestConfig) {
        return PromoCodePublicApiFp(this.configuration).promoCodePublicControllerVerifyPromoCode(requestParameters.validatePromoCodeDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrywatnoRecepcjiGosowejApi - axios parameter creator
 * @export
 */
export const PrywatnoRecepcjiGosowejApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz wersjonowaną informację o prywatności
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerReadNotice: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voicePrivacyControllerReadNotice', 'organizationId', organizationId)
            const localVarPath = `/public/voice-privacy/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Rozpocznij weryfikację OTP wniosku o dane
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {StartVoiceDsrDto} startVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerStart: async (organizationId: string, startVoiceDsrDto: StartVoiceDsrDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voicePrivacyControllerStart', 'organizationId', organizationId)
            // verify required parameter 'startVoiceDsrDto' is not null or undefined
            assertParamExists('voicePrivacyControllerStart', 'startVoiceDsrDto', startVoiceDsrDto)
            const localVarPath = `/public/voice-privacy/{organizationId}/data-subject-requests/start`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startVoiceDsrDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Pobierz zminimalizowany status zweryfikowanego wniosku
         * @param {string} requestId
         * @param {VoiceDsrStatusQueryDto} voiceDsrStatusQueryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerStatus: async (requestId: string, voiceDsrStatusQueryDto: VoiceDsrStatusQueryDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voicePrivacyControllerStatus', 'requestId', requestId)
            // verify required parameter 'voiceDsrStatusQueryDto' is not null or undefined
            assertParamExists('voicePrivacyControllerStatus', 'voiceDsrStatusQueryDto', voiceDsrStatusQueryDto)
            const localVarPath = `/public/voice-privacy/data-subject-requests/{requestId}/status`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voiceDsrStatusQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Potwierdź OTP i przekaż wniosek do oceny człowieka
         * @param {string} requestId
         * @param {VerifyVoiceDsrDto} verifyVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerVerify: async (requestId: string, verifyVoiceDsrDto: VerifyVoiceDsrDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('voicePrivacyControllerVerify', 'requestId', requestId)
            // verify required parameter 'verifyVoiceDsrDto' is not null or undefined
            assertParamExists('voicePrivacyControllerVerify', 'verifyVoiceDsrDto', verifyVoiceDsrDto)
            const localVarPath = `/public/voice-privacy/data-subject-requests/{requestId}/verify`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyVoiceDsrDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrywatnoRecepcjiGosowejApi - functional programming interface
 * @export
 */
export const PrywatnoRecepcjiGosowejApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrywatnoRecepcjiGosowejApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz wersjonowaną informację o prywatności
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePrivacyControllerReadNotice(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoicePrivacyNoticeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePrivacyControllerReadNotice(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Rozpocznij weryfikację OTP wniosku o dane
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {StartVoiceDsrDto} startVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePrivacyControllerStart(organizationId: string, startVoiceDsrDto: StartVoiceDsrDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrStartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePrivacyControllerStart(organizationId, startVoiceDsrDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Pobierz zminimalizowany status zweryfikowanego wniosku
         * @param {string} requestId
         * @param {VoiceDsrStatusQueryDto} voiceDsrStatusQueryDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePrivacyControllerStatus(requestId: string, voiceDsrStatusQueryDto: VoiceDsrStatusQueryDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePrivacyControllerStatus(requestId, voiceDsrStatusQueryDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Potwierdź OTP i przekaż wniosek do oceny człowieka
         * @param {string} requestId
         * @param {VerifyVoiceDsrDto} verifyVoiceDsrDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voicePrivacyControllerVerify(requestId: string, verifyVoiceDsrDto: VerifyVoiceDsrDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDsrVerifiedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voicePrivacyControllerVerify(requestId, verifyVoiceDsrDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrywatnoRecepcjiGosowejApi - factory interface
 * @export
 */
export const PrywatnoRecepcjiGosowejApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrywatnoRecepcjiGosowejApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz wersjonowaną informację o prywatności
         * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerReadNotice(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest, options?: AxiosRequestConfig): AxiosPromise<VoicePrivacyNoticeDto> {
            return localVarFp.voicePrivacyControllerReadNotice(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Rozpocznij weryfikację OTP wniosku o dane
         * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerStart(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrStartResponseDto> {
            return localVarFp.voicePrivacyControllerStart(requestParameters.organizationId, requestParameters.startVoiceDsrDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pobierz zminimalizowany status zweryfikowanego wniosku
         * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerStatus(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrStatusResponseDto> {
            return localVarFp.voicePrivacyControllerStatus(requestParameters.requestId, requestParameters.voiceDsrStatusQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Potwierdź OTP i przekaż wniosek do oceny człowieka
         * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voicePrivacyControllerVerify(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDsrVerifiedResponseDto> {
            return localVarFp.voicePrivacyControllerVerify(requestParameters.requestId, requestParameters.verifyVoiceDsrDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voicePrivacyControllerReadNotice operation in PrywatnoRecepcjiGosowejApi.
 * @export
 * @interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest
 */
export interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest {
    /**
     * Identyfikator ObjectId albo publiczny slug placówki
     * @type {string}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNotice
     */
    readonly organizationId: string
}

/**
 * Request parameters for voicePrivacyControllerStart operation in PrywatnoRecepcjiGosowejApi.
 * @export
 * @interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest
 */
export interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest {
    /**
     * Identyfikator ObjectId albo publiczny slug placówki
     * @type {string}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStart
     */
    readonly organizationId: string

    /**
     *
     * @type {StartVoiceDsrDto}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStart
     */
    readonly startVoiceDsrDto: StartVoiceDsrDto
}

/**
 * Request parameters for voicePrivacyControllerStatus operation in PrywatnoRecepcjiGosowejApi.
 * @export
 * @interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest
 */
export interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest {
    /**
     *
     * @type {string}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatus
     */
    readonly requestId: string

    /**
     *
     * @type {VoiceDsrStatusQueryDto}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatus
     */
    readonly voiceDsrStatusQueryDto: VoiceDsrStatusQueryDto
}

/**
 * Request parameters for voicePrivacyControllerVerify operation in PrywatnoRecepcjiGosowejApi.
 * @export
 * @interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest
 */
export interface PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest {
    /**
     *
     * @type {string}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerify
     */
    readonly requestId: string

    /**
     *
     * @type {VerifyVoiceDsrDto}
     * @memberof PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerify
     */
    readonly verifyVoiceDsrDto: VerifyVoiceDsrDto
}

/**
 * PrywatnoRecepcjiGosowejApi - object-oriented interface
 * @export
 * @class PrywatnoRecepcjiGosowejApi
 * @extends {BaseAPI}
 */
export class PrywatnoRecepcjiGosowejApi extends BaseAPI {
    /**
     *
     * @summary Pobierz wersjonowaną informację o prywatności
     * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrywatnoRecepcjiGosowejApi
     */
    public voicePrivacyControllerReadNotice(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerReadNoticeRequest, options?: AxiosRequestConfig) {
        return PrywatnoRecepcjiGosowejApiFp(this.configuration).voicePrivacyControllerReadNotice(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Rozpocznij weryfikację OTP wniosku o dane
     * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrywatnoRecepcjiGosowejApi
     */
    public voicePrivacyControllerStart(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStartRequest, options?: AxiosRequestConfig) {
        return PrywatnoRecepcjiGosowejApiFp(this.configuration).voicePrivacyControllerStart(requestParameters.organizationId, requestParameters.startVoiceDsrDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Pobierz zminimalizowany status zweryfikowanego wniosku
     * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrywatnoRecepcjiGosowejApi
     */
    public voicePrivacyControllerStatus(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerStatusRequest, options?: AxiosRequestConfig) {
        return PrywatnoRecepcjiGosowejApiFp(this.configuration).voicePrivacyControllerStatus(requestParameters.requestId, requestParameters.voiceDsrStatusQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Potwierdź OTP i przekaż wniosek do oceny człowieka
     * @param {PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrywatnoRecepcjiGosowejApi
     */
    public voicePrivacyControllerVerify(requestParameters: PrywatnoRecepcjiGosowejApiVoicePrivacyControllerVerifyRequest, options?: AxiosRequestConfig) {
        return PrywatnoRecepcjiGosowejApiFp(this.configuration).voicePrivacyControllerVerify(requestParameters.requestId, requestParameters.verifyVoiceDsrDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PublicWebinarsApi - axios parameter creator
 * @export
 */
export const PublicWebinarsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @param {string} slug
         * @param {WebinarAdmissionDto} webinarAdmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerAdmit: async (slug: string, webinarAdmissionDto: WebinarAdmissionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('webinarControllerAdmit', 'slug', slug)
            // verify required parameter 'webinarAdmissionDto' is not null or undefined
            assertParamExists('webinarControllerAdmit', 'webinarAdmissionDto', webinarAdmissionDto)
            const localVarPath = `/public/webinars/{slug}/admit`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarAdmissionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarConfirmDto} webinarConfirmDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerConfirm: async (slug: string, webinarConfirmDto: WebinarConfirmDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('webinarControllerConfirm', 'slug', slug)
            // verify required parameter 'webinarConfirmDto' is not null or undefined
            assertParamExists('webinarControllerConfirm', 'webinarConfirmDto', webinarConfirmDto)
            const localVarPath = `/public/webinars/{slug}/confirm`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarConfirmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/webinars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerMetadata: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('webinarControllerMetadata', 'slug', slug)
            const localVarPath = `/public/webinars/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarRegistrationDto} webinarRegistrationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRegister: async (slug: string, webinarRegistrationDto: WebinarRegistrationDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('webinarControllerRegister', 'slug', slug)
            // verify required parameter 'webinarRegistrationDto' is not null or undefined
            assertParamExists('webinarControllerRegister', 'webinarRegistrationDto', webinarRegistrationDto)
            const localVarPath = `/public/webinars/{slug}/register`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarRegistrationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebinarRehearsalJoinDto} webinarRehearsalJoinDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsalJoin: async (webinarRehearsalJoinDto: WebinarRehearsalJoinDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webinarRehearsalJoinDto' is not null or undefined
            assertParamExists('webinarControllerRehearsalJoin', 'webinarRehearsalJoinDto', webinarRehearsalJoinDto)
            const localVarPath = `/public/webinars/rehearsal/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarRehearsalJoinDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebinarRehearsalAccessDto} webinarRehearsalAccessDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsalPreview: async (webinarRehearsalAccessDto: WebinarRehearsalAccessDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webinarRehearsalAccessDto' is not null or undefined
            assertParamExists('webinarControllerRehearsalPreview', 'webinarRehearsalAccessDto', webinarRehearsalAccessDto)
            const localVarPath = `/public/webinars/rehearsal/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarRehearsalAccessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarVerificationResendDto} webinarVerificationResendDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerResendVerification: async (slug: string, webinarVerificationResendDto: WebinarVerificationResendDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('webinarControllerResendVerification', 'slug', slug)
            // verify required parameter 'webinarVerificationResendDto' is not null or undefined
            assertParamExists('webinarControllerResendVerification', 'webinarVerificationResendDto', webinarVerificationResendDto)
            const localVarPath = `/public/webinars/{slug}/resend-verification`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarVerificationResendDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebinarStaffJoinDto} webinarStaffJoinDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerStaffJoin: async (webinarStaffJoinDto: WebinarStaffJoinDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webinarStaffJoinDto' is not null or undefined
            assertParamExists('webinarControllerStaffJoin', 'webinarStaffJoinDto', webinarStaffJoinDto)
            const localVarPath = `/public/webinars/staff/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarStaffJoinDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {WebinarStaffAccessDto} webinarStaffAccessDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerStaffPreview: async (webinarStaffAccessDto: WebinarStaffAccessDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webinarStaffAccessDto' is not null or undefined
            assertParamExists('webinarControllerStaffPreview', 'webinarStaffAccessDto', webinarStaffAccessDto)
            const localVarPath = `/public/webinars/staff/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webinarStaffAccessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicWebinarsApi - functional programming interface
 * @export
 */
export const PublicWebinarsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicWebinarsApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @param {string} slug
         * @param {WebinarAdmissionDto} webinarAdmissionDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerAdmit(slug: string, webinarAdmissionDto: WebinarAdmissionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAdmissionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerAdmit(slug, webinarAdmissionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarConfirmDto} webinarConfirmDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerConfirm(slug: string, webinarConfirmDto: WebinarConfirmDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarConfirmationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerConfirm(slug, webinarConfirmDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PublicWebinarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerMetadata(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicWebinarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerMetadata(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarRegistrationDto} webinarRegistrationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRegister(slug: string, webinarRegistrationDto: WebinarRegistrationDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRegistrationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRegister(slug, webinarRegistrationDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {WebinarRehearsalJoinDto} webinarRehearsalJoinDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRehearsalJoin(webinarRehearsalJoinDto: WebinarRehearsalJoinDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAdmissionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRehearsalJoin(webinarRehearsalJoinDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {WebinarRehearsalAccessDto} webinarRehearsalAccessDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerRehearsalPreview(webinarRehearsalAccessDto: WebinarRehearsalAccessDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRehearsalPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerRehearsalPreview(webinarRehearsalAccessDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {string} slug
         * @param {WebinarVerificationResendDto} webinarVerificationResendDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerResendVerification(slug: string, webinarVerificationResendDto: WebinarVerificationResendDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarRegistrationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerResendVerification(slug, webinarVerificationResendDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {WebinarStaffJoinDto} webinarStaffJoinDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerStaffJoin(webinarStaffJoinDto: WebinarStaffJoinDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarAdmissionResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerStaffJoin(webinarStaffJoinDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @param {WebinarStaffAccessDto} webinarStaffAccessDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async webinarControllerStaffPreview(webinarStaffAccessDto: WebinarStaffAccessDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarStaffPreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.webinarControllerStaffPreview(webinarStaffAccessDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicWebinarsApi - factory interface
 * @export
 */
export const PublicWebinarsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicWebinarsApiFp(configuration)
    return {
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerAdmitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerAdmit(requestParameters: PublicWebinarsApiWebinarControllerAdmitRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarAdmissionResultDto> {
            return localVarFp.webinarControllerAdmit(requestParameters.slug, requestParameters.webinarAdmissionDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerConfirmRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerConfirm(requestParameters: PublicWebinarsApiWebinarControllerConfirmRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarConfirmationResultDto> {
            return localVarFp.webinarControllerConfirm(requestParameters.slug, requestParameters.webinarConfirmDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerList(options?: AxiosRequestConfig): AxiosPromise<Array<PublicWebinarDto>> {
            return localVarFp.webinarControllerList(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerMetadataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerMetadata(requestParameters: PublicWebinarsApiWebinarControllerMetadataRequest, options?: AxiosRequestConfig): AxiosPromise<PublicWebinarDto> {
            return localVarFp.webinarControllerMetadata(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerRegisterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRegister(requestParameters: PublicWebinarsApiWebinarControllerRegisterRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRegistrationResultDto> {
            return localVarFp.webinarControllerRegister(requestParameters.slug, requestParameters.webinarRegistrationDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerRehearsalJoinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsalJoin(requestParameters: PublicWebinarsApiWebinarControllerRehearsalJoinRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarAdmissionResultDto> {
            return localVarFp.webinarControllerRehearsalJoin(requestParameters.webinarRehearsalJoinDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerRehearsalPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerRehearsalPreview(requestParameters: PublicWebinarsApiWebinarControllerRehearsalPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRehearsalPreviewDto> {
            return localVarFp.webinarControllerRehearsalPreview(requestParameters.webinarRehearsalAccessDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerResendVerificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerResendVerification(requestParameters: PublicWebinarsApiWebinarControllerResendVerificationRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarRegistrationResultDto> {
            return localVarFp.webinarControllerResendVerification(requestParameters.slug, requestParameters.webinarVerificationResendDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerStaffJoinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerStaffJoin(requestParameters: PublicWebinarsApiWebinarControllerStaffJoinRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarAdmissionResultDto> {
            return localVarFp.webinarControllerStaffJoin(requestParameters.webinarStaffJoinDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {PublicWebinarsApiWebinarControllerStaffPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        webinarControllerStaffPreview(requestParameters: PublicWebinarsApiWebinarControllerStaffPreviewRequest, options?: AxiosRequestConfig): AxiosPromise<WebinarStaffPreviewDto> {
            return localVarFp.webinarControllerStaffPreview(requestParameters.webinarStaffAccessDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for webinarControllerAdmit operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerAdmitRequest
 */
export interface PublicWebinarsApiWebinarControllerAdmitRequest {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarsApiWebinarControllerAdmit
     */
    readonly slug: string

    /**
     *
     * @type {WebinarAdmissionDto}
     * @memberof PublicWebinarsApiWebinarControllerAdmit
     */
    readonly webinarAdmissionDto: WebinarAdmissionDto
}

/**
 * Request parameters for webinarControllerConfirm operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerConfirmRequest
 */
export interface PublicWebinarsApiWebinarControllerConfirmRequest {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarsApiWebinarControllerConfirm
     */
    readonly slug: string

    /**
     *
     * @type {WebinarConfirmDto}
     * @memberof PublicWebinarsApiWebinarControllerConfirm
     */
    readonly webinarConfirmDto: WebinarConfirmDto
}

/**
 * Request parameters for webinarControllerMetadata operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerMetadataRequest
 */
export interface PublicWebinarsApiWebinarControllerMetadataRequest {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarsApiWebinarControllerMetadata
     */
    readonly slug: string
}

/**
 * Request parameters for webinarControllerRegister operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerRegisterRequest
 */
export interface PublicWebinarsApiWebinarControllerRegisterRequest {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarsApiWebinarControllerRegister
     */
    readonly slug: string

    /**
     *
     * @type {WebinarRegistrationDto}
     * @memberof PublicWebinarsApiWebinarControllerRegister
     */
    readonly webinarRegistrationDto: WebinarRegistrationDto
}

/**
 * Request parameters for webinarControllerRehearsalJoin operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerRehearsalJoinRequest
 */
export interface PublicWebinarsApiWebinarControllerRehearsalJoinRequest {
    /**
     *
     * @type {WebinarRehearsalJoinDto}
     * @memberof PublicWebinarsApiWebinarControllerRehearsalJoin
     */
    readonly webinarRehearsalJoinDto: WebinarRehearsalJoinDto
}

/**
 * Request parameters for webinarControllerRehearsalPreview operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerRehearsalPreviewRequest
 */
export interface PublicWebinarsApiWebinarControllerRehearsalPreviewRequest {
    /**
     *
     * @type {WebinarRehearsalAccessDto}
     * @memberof PublicWebinarsApiWebinarControllerRehearsalPreview
     */
    readonly webinarRehearsalAccessDto: WebinarRehearsalAccessDto
}

/**
 * Request parameters for webinarControllerResendVerification operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerResendVerificationRequest
 */
export interface PublicWebinarsApiWebinarControllerResendVerificationRequest {
    /**
     *
     * @type {string}
     * @memberof PublicWebinarsApiWebinarControllerResendVerification
     */
    readonly slug: string

    /**
     *
     * @type {WebinarVerificationResendDto}
     * @memberof PublicWebinarsApiWebinarControllerResendVerification
     */
    readonly webinarVerificationResendDto: WebinarVerificationResendDto
}

/**
 * Request parameters for webinarControllerStaffJoin operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerStaffJoinRequest
 */
export interface PublicWebinarsApiWebinarControllerStaffJoinRequest {
    /**
     *
     * @type {WebinarStaffJoinDto}
     * @memberof PublicWebinarsApiWebinarControllerStaffJoin
     */
    readonly webinarStaffJoinDto: WebinarStaffJoinDto
}

/**
 * Request parameters for webinarControllerStaffPreview operation in PublicWebinarsApi.
 * @export
 * @interface PublicWebinarsApiWebinarControllerStaffPreviewRequest
 */
export interface PublicWebinarsApiWebinarControllerStaffPreviewRequest {
    /**
     *
     * @type {WebinarStaffAccessDto}
     * @memberof PublicWebinarsApiWebinarControllerStaffPreview
     */
    readonly webinarStaffAccessDto: WebinarStaffAccessDto
}

/**
 * PublicWebinarsApi - object-oriented interface
 * @export
 * @class PublicWebinarsApi
 * @extends {BaseAPI}
 */
export class PublicWebinarsApi extends BaseAPI {
    /**
     *
     * @param {PublicWebinarsApiWebinarControllerAdmitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerAdmit(requestParameters: PublicWebinarsApiWebinarControllerAdmitRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerAdmit(requestParameters.slug, requestParameters.webinarAdmissionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerConfirmRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerConfirm(requestParameters: PublicWebinarsApiWebinarControllerConfirmRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerConfirm(requestParameters.slug, requestParameters.webinarConfirmDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerList(options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerMetadataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerMetadata(requestParameters: PublicWebinarsApiWebinarControllerMetadataRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerMetadata(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerRegisterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerRegister(requestParameters: PublicWebinarsApiWebinarControllerRegisterRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerRegister(requestParameters.slug, requestParameters.webinarRegistrationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerRehearsalJoinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerRehearsalJoin(requestParameters: PublicWebinarsApiWebinarControllerRehearsalJoinRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerRehearsalJoin(requestParameters.webinarRehearsalJoinDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerRehearsalPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerRehearsalPreview(requestParameters: PublicWebinarsApiWebinarControllerRehearsalPreviewRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerRehearsalPreview(requestParameters.webinarRehearsalAccessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerResendVerificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerResendVerification(requestParameters: PublicWebinarsApiWebinarControllerResendVerificationRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerResendVerification(requestParameters.slug, requestParameters.webinarVerificationResendDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerStaffJoinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerStaffJoin(requestParameters: PublicWebinarsApiWebinarControllerStaffJoinRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerStaffJoin(requestParameters.webinarStaffJoinDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @param {PublicWebinarsApiWebinarControllerStaffPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicWebinarsApi
     */
    public webinarControllerStaffPreview(requestParameters: PublicWebinarsApiWebinarControllerStaffPreviewRequest, options?: AxiosRequestConfig) {
        return PublicWebinarsApiFp(this.configuration).webinarControllerStaffPreview(requestParameters.webinarStaffAccessDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SpecializationPublicApi - axios parameter creator
 * @export
 */
export const SpecializationPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all specializations (public access)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationPublicControllerGetAllSpecializations: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/specialization/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecializationPublicApi - functional programming interface
 * @export
 */
export const SpecializationPublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpecializationPublicApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all specializations (public access)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specializationPublicControllerGetAllSpecializations(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetSpecializationDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specializationPublicControllerGetAllSpecializations(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SpecializationPublicApi - factory interface
 * @export
 */
export const SpecializationPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpecializationPublicApiFp(configuration)
    return {
        /**
         *
         * @summary Get all specializations (public access)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specializationPublicControllerGetAllSpecializations(options?: AxiosRequestConfig): AxiosPromise<Array<GetSpecializationDto>> {
            return localVarFp.specializationPublicControllerGetAllSpecializations(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SpecializationPublicApi - object-oriented interface
 * @export
 * @class SpecializationPublicApi
 * @extends {BaseAPI}
 */
export class SpecializationPublicApi extends BaseAPI {
    /**
     *
     * @summary Get all specializations (public access)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecializationPublicApi
     */
    public specializationPublicControllerGetAllSpecializations(options?: AxiosRequestConfig) {
        return SpecializationPublicApiFp(this.configuration).specializationPublicControllerGetAllSpecializations(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Guest-uploaded attachment (private bucket; access via signed URL only)
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadGuestAttachment: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/upload/guest-attachment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Guest-uploaded attachment (private bucket; access via signed URL only)
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadControllerUploadGuestAttachment(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestAttachmentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadControllerUploadGuestAttachment(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadApiFp(configuration)
    return {
        /**
         *
         * @summary Guest-uploaded attachment (private bucket; access via signed URL only)
         * @param {UploadApiUploadControllerUploadGuestAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadControllerUploadGuestAttachment(requestParameters: UploadApiUploadControllerUploadGuestAttachmentRequest = {}, options?: AxiosRequestConfig): AxiosPromise<GuestAttachmentResponseDto> {
            return localVarFp.uploadControllerUploadGuestAttachment(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for uploadControllerUploadGuestAttachment operation in UploadApi.
 * @export
 * @interface UploadApiUploadControllerUploadGuestAttachmentRequest
 */
export interface UploadApiUploadControllerUploadGuestAttachmentRequest {
    /**
     *
     * @type {File}
     * @memberof UploadApiUploadControllerUploadGuestAttachment
     */
    readonly file?: File
}

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
    /**
     *
     * @summary Guest-uploaded attachment (private bucket; access via signed URL only)
     * @param {UploadApiUploadControllerUploadGuestAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadApi
     */
    public uploadControllerUploadGuestAttachment(requestParameters: UploadApiUploadControllerUploadGuestAttachmentRequest = {}, options?: AxiosRequestConfig) {
        return UploadApiFp(this.configuration).uploadControllerUploadGuestAttachment(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VetReferralApi - axios parameter creator
 * @export
 */
export const VetReferralApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit a referral for a veterinarian to join Vetsi. Rate limited to 3 requests per minute.
         * @summary Submit veterinarian referral
         * @param {VetReferralDto} vetReferralDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vetReferralControllerSubmitReferral: async (vetReferralDto: VetReferralDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vetReferralDto' is not null or undefined
            assertParamExists('vetReferralControllerSubmitReferral', 'vetReferralDto', vetReferralDto)
            const localVarPath = `/public/vet-referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vetReferralDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VetReferralApi - functional programming interface
 * @export
 */
export const VetReferralApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VetReferralApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit a referral for a veterinarian to join Vetsi. Rate limited to 3 requests per minute.
         * @summary Submit veterinarian referral
         * @param {VetReferralDto} vetReferralDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vetReferralControllerSubmitReferral(vetReferralDto: VetReferralDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vetReferralControllerSubmitReferral(vetReferralDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VetReferralApi - factory interface
 * @export
 */
export const VetReferralApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VetReferralApiFp(configuration)
    return {
        /**
         * Submit a referral for a veterinarian to join Vetsi. Rate limited to 3 requests per minute.
         * @summary Submit veterinarian referral
         * @param {VetReferralApiVetReferralControllerSubmitReferralRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vetReferralControllerSubmitReferral(requestParameters: VetReferralApiVetReferralControllerSubmitReferralRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.vetReferralControllerSubmitReferral(requestParameters.vetReferralDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for vetReferralControllerSubmitReferral operation in VetReferralApi.
 * @export
 * @interface VetReferralApiVetReferralControllerSubmitReferralRequest
 */
export interface VetReferralApiVetReferralControllerSubmitReferralRequest {
    /**
     *
     * @type {VetReferralDto}
     * @memberof VetReferralApiVetReferralControllerSubmitReferral
     */
    readonly vetReferralDto: VetReferralDto
}

/**
 * VetReferralApi - object-oriented interface
 * @export
 * @class VetReferralApi
 * @extends {BaseAPI}
 */
export class VetReferralApi extends BaseAPI {
    /**
     * Submit a referral for a veterinarian to join Vetsi. Rate limited to 3 requests per minute.
     * @summary Submit veterinarian referral
     * @param {VetReferralApiVetReferralControllerSubmitReferralRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VetReferralApi
     */
    public vetReferralControllerSubmitReferral(requestParameters: VetReferralApiVetReferralControllerSubmitReferralRequest, options?: AxiosRequestConfig) {
        return VetReferralApiFp(this.configuration).vetReferralControllerSubmitReferral(requestParameters.vetReferralDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VisitPublicApi - axios parameter creator
 * @export
 */
export const VisitPublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Signed URL for a private file attached to the visit (via documents collection)
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestAttachmentControllerGetSignedUrl: async (visitId: string, filename: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestAttachmentControllerGetSignedUrl', 'visitId', visitId)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('visitGuestAttachmentControllerGetSignedUrl', 'filename', filename)
            const localVarPath = `/public/visit/{visitId}/document-files/{filename}/signed-url`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Guest-session upload of a private file attached to the visit. Returns the GCS filename; the canonical Document row is created by the modal submit (documentsToAdd → updateDetails).
         * @param {string} visitId
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestAttachmentControllerUploadVisitPrivate: async (visitId: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestAttachmentControllerUploadVisitPrivate', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/upload-private`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) {
                localVarFormParams.append('file', file as any);
            }


            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Verify the replacement contact, rotate Guest credentials, and send a fresh Manage Link.
         * @param {string} visitId
         * @param {GuestContactChangeCompleteDto} guestContactChangeCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestContactChangeControllerComplete: async (visitId: string, guestContactChangeCompleteDto: GuestContactChangeCompleteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestContactChangeControllerComplete', 'visitId', visitId)
            // verify required parameter 'guestContactChangeCompleteDto' is not null or undefined
            assertParamExists('visitGuestContactChangeControllerComplete', 'guestContactChangeCompleteDto', guestContactChangeCompleteDto)
            const localVarPath = `/public/visit/{visitId}/contact-change/complete`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestContactChangeCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Send an OTP to a replacement Confirmed Contact for an authenticated Guest Visit.
         * @param {string} visitId
         * @param {GuestContactChangeStartDto} guestContactChangeStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestContactChangeControllerStart: async (visitId: string, guestContactChangeStartDto: GuestContactChangeStartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestContactChangeControllerStart', 'visitId', visitId)
            // verify required parameter 'guestContactChangeStartDto' is not null or undefined
            assertParamExists('visitGuestContactChangeControllerStart', 'guestContactChangeStartDto', guestContactChangeStartDto)
            const localVarPath = `/public/visit/{visitId}/contact-change/start`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestContactChangeStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL visit. 409 if the visit is not in that state.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerApprove: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerApprove', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/approve`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Cancel the visit (guest-session gated)
         * @param {string} visitId
         * @param {GuestCancelVisitDto} guestCancelVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerCancel: async (visitId: string, guestCancelVisitDto: GuestCancelVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerCancel', 'visitId', visitId)
            // verify required parameter 'guestCancelVisitDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerCancel', 'guestCancelVisitDto', guestCancelVisitDto)
            const localVarPath = `/public/visit/{visitId}/cancel`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestCancelVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Delete a reminder bound to this visit (guest-session gated).
         * @param {string} visitId
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerDeleteReminder: async (visitId: string, reminderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerDeleteReminder', 'visitId', visitId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerDeleteReminder', 'reminderId', reminderId)
            const localVarPath = `/public/visit/{visitId}/reminders/{reminderId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Return upcoming available slots for the visit professional, for the reschedule modal.
         * @param {string} visitId
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerGetAvailableSlots: async (visitId: string, slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerGetAvailableSlots', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/available-slots`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slotsPerDay !== undefined) {
                localVarQueryParameter['slotsPerDay'] = slotsPerDay;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Fetch full visit detail for an authenticated guest session. Post-visit content is gated on status.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerGetVisit: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerGetVisit', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror of the URL-token retry). Returns the new P24 checkout URL.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerPaymentRetry: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerPaymentRetry', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/payment/retry`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Submit a rating for the completed guest visit (guest-session gated). 400 if not a guest visit or not completed; 409 if already rated.
         * @param {string} visitId
         * @param {GuestRateVisitDto} guestRateVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerRate: async (visitId: string, guestRateVisitDto: GuestRateVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerRate', 'visitId', visitId)
            // verify required parameter 'guestRateVisitDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerRate', 'guestRateVisitDto', guestRateVisitDto)
            const localVarPath = `/public/visit/{visitId}/rating`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestRateVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL visit (terminal — sessions are revoked). 409 if the visit is not in that state.
         * @param {string} visitId
         * @param {GuestRejectVisitDto} guestRejectVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerReject: async (visitId: string, guestRejectVisitDto: GuestRejectVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerReject', 'visitId', visitId)
            // verify required parameter 'guestRejectVisitDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerReject', 'guestRejectVisitDto', guestRejectVisitDto)
            const localVarPath = `/public/visit/{visitId}/reject`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestRejectVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Reschedule the visit (guest-session gated)
         * @param {string} visitId
         * @param {GuestRescheduleVisitDto} guestRescheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerReschedule: async (visitId: string, guestRescheduleVisitDto: GuestRescheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerReschedule', 'visitId', visitId)
            // verify required parameter 'guestRescheduleVisitDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerReschedule', 'guestRescheduleVisitDto', guestRescheduleVisitDto)
            const localVarPath = `/public/visit/{visitId}/reschedule`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestRescheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit description (\"Dolegliwości\") and attached documents (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {string} visitId
         * @param {GuestUpdateVisitDetailsDto} guestUpdateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateDetails: async (visitId: string, guestUpdateVisitDetailsDto: GuestUpdateVisitDetailsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateDetails', 'visitId', visitId)
            // verify required parameter 'guestUpdateVisitDetailsDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateDetails', 'guestUpdateVisitDetailsDto', guestUpdateVisitDetailsDto)
            const localVarPath = `/public/visit/{visitId}/details`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestUpdateVisitDetailsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData (guest-session gated). 400 if the visit is not a guest visit.
         * @param {string} visitId
         * @param {GuestUpdateProfileDataDto} guestUpdateProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateProfileData: async (visitId: string, guestUpdateProfileDataDto: GuestUpdateProfileDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateProfileData', 'visitId', visitId)
            // verify required parameter 'guestUpdateProfileDataDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateProfileData', 'guestUpdateProfileDataDto', guestUpdateProfileDataDto)
            const localVarPath = `/public/visit/{visitId}/profile-data`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestUpdateProfileDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a reminder bound to this visit (guest-session gated). Editable fields: description, scheduledAt, notificationChannels.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {GuestUpdateReminderDto} guestUpdateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateReminder: async (visitId: string, reminderId: string, guestUpdateReminderDto: GuestUpdateReminderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateReminder', 'visitId', visitId)
            // verify required parameter 'reminderId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateReminder', 'reminderId', reminderId)
            // verify required parameter 'guestUpdateReminderDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateReminder', 'guestUpdateReminderDto', guestUpdateReminderDto)
            const localVarPath = `/public/visit/{visitId}/reminders/{reminderId}`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)))
                .replace(`{${"reminderId"}}`, encodeURIComponent(String(reminderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestUpdateReminderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {string} visitId
         * @param {GuestUpdateUserDataDto} guestUpdateUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateUserData: async (visitId: string, guestUpdateUserDataDto: GuestUpdateUserDataDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateUserData', 'visitId', visitId)
            // verify required parameter 'guestUpdateUserDataDto' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerUpdateUserData', 'guestUpdateUserDataDto', guestUpdateUserDataDto)
            const localVarPath = `/public/visit/{visitId}/user-data`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestUpdateUserDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a Twilio video access token for the guest visit (session-gated). 404 if the room is not live.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerVideoToken: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestManagementPublicControllerVideoToken', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/video-token`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Trade a verify code (SMS) or nonce (email magic link) for a guest session.
         * @param {string} visitId
         * @param {string} userAgent
         * @param {GuestVerifyCompleteDto} guestVerifyCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerComplete: async (visitId: string, userAgent: string, guestVerifyCompleteDto: GuestVerifyCompleteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestVerifyControllerComplete', 'visitId', visitId)
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('visitGuestVerifyControllerComplete', 'userAgent', userAgent)
            // verify required parameter 'guestVerifyCompleteDto' is not null or undefined
            assertParamExists('visitGuestVerifyControllerComplete', 'guestVerifyCompleteDto', guestVerifyCompleteDto)
            const localVarPath = `/public/visit/{visitId}/verify/complete`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestVerifyCompleteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Mint a verify challenge for the guest-visit page. Dispatches an email magic link or an SMS code (per `channel`) and returns the masked destination + challenge id.
         * @param {string} visitId
         * @param {GuestVerifyStartDto} guestVerifyStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerStart: async (visitId: string, guestVerifyStartDto: GuestVerifyStartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitGuestVerifyControllerStart', 'visitId', visitId)
            // verify required parameter 'guestVerifyStartDto' is not null or undefined
            assertParamExists('visitGuestVerifyControllerStart', 'guestVerifyStartDto', guestVerifyStartDto)
            const localVarPath = `/public/visit/{visitId}/verify/start`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestVerifyStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Exchange a single-use first-party Voice booking Manage Link for a bounded Guest session.
         * @param {string} userAgent
         * @param {GuestManageLinkStartDto} guestManageLinkStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerStartFromManageLink: async (userAgent: string, guestManageLinkStartDto: GuestManageLinkStartDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('visitGuestVerifyControllerStartFromManageLink', 'userAgent', userAgent)
            // verify required parameter 'guestManageLinkStartDto' is not null or undefined
            assertParamExists('visitGuestVerifyControllerStartFromManageLink', 'guestManageLinkStartDto', guestManageLinkStartDto)
            const localVarPath = `/public/visit/guest-manage-link/verify/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestManageLinkStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetAllCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/visit/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current payment status for a guest-booked visit.
         * @summary Get the payment status for a guest visit
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetGuestPaymentStatus: async (visitId: string, guestAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitPublicControllerGetGuestPaymentStatus', 'visitId', visitId)
            // verify required parameter 'guestAccessToken' is not null or undefined
            assertParamExists('visitPublicControllerGetGuestPaymentStatus', 'guestAccessToken', guestAccessToken)
            const localVarPath = `/public/visit/{visitId}/payment-status`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (guestAccessToken !== undefined) {
                localVarQueryParameter['guestAccessToken'] = guestAccessToken;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns minimal visit info for the confirmation page. Only guest visits (no linked user/profile) are accessible.
         * @summary Fetch the summary for a guest-booked visit
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetGuestVisitSummary: async (visitId: string, guestAccessToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitPublicControllerGetGuestVisitSummary', 'visitId', visitId)
            // verify required parameter 'guestAccessToken' is not null or undefined
            assertParamExists('visitPublicControllerGetGuestVisitSummary', 'guestAccessToken', guestAccessToken)
            const localVarPath = `/public/visit/{visitId}/guest-summary`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (guestAccessToken !== undefined) {
                localVarQueryParameter['guestAccessToken'] = guestAccessToken;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {string} professionalId
         * @param {string} category
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} [visitType] Visit mode required for the availability window
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetProfessionalAvailableSlots: async (professionalId: string, category: string, slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, visitType?: 'video' | 'chat' | 'onsite' | 'mobile', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'professionalId' is not null or undefined
            assertParamExists('visitPublicControllerGetProfessionalAvailableSlots', 'professionalId', professionalId)
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitPublicControllerGetProfessionalAvailableSlots', 'category', category)
            const localVarPath = `/public/visit/professional/{professionalId}/slots/{category}`
                .replace(`{${"professionalId"}}`, encodeURIComponent(String(professionalId)))
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slotsPerDay !== undefined) {
                localVarQueryParameter['slotsPerDay'] = slotsPerDay;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (duration !== undefined) {
                localVarQueryParameter['duration'] = duration;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (visitType !== undefined) {
                localVarQueryParameter['visitType'] = visitType;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get available slots for multiple professionals
         * @param {string} category
         * @param {GetProfessionalsSlotsDto} getProfessionalsSlotsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetProfessionalsAvailableSlots: async (category: string, getProfessionalsSlotsDto: GetProfessionalsSlotsDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitPublicControllerGetProfessionalsAvailableSlots', 'category', category)
            // verify required parameter 'getProfessionalsSlotsDto' is not null or undefined
            assertParamExists('visitPublicControllerGetProfessionalsAvailableSlots', 'getProfessionalsSlotsDto', getProfessionalsSlotsDto)
            const localVarPath = `/public/visit/professionals/slots/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getProfessionalsSlotsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get availability slots
         * @param {string} category
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetUpcoming2weeksVisitSlots: async (category: string, organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('visitPublicControllerGetUpcoming2weeksVisitSlots', 'category', category)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitPublicControllerGetUpcoming2weeksVisitSlots', 'organizationId', organizationId)
            const localVarPath = `/public/visit/available/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get upcoming visit slot
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetUpcomingVisitSlot: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('visitPublicControllerGetUpcomingVisitSlot', 'organizationId', organizationId)
            const localVarPath = `/public/visit/upcoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Retry a failed guest payment (token-gated). Returns a fresh P24 checkout URL.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerRetryGuestPayment: async (visitId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'visitId' is not null or undefined
            assertParamExists('visitPublicControllerRetryGuestPayment', 'visitId', visitId)
            const localVarPath = `/public/visit/{visitId}/guest-payment/retry`
                .replace(`{${"visitId"}}`, encodeURIComponent(String(visitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Create a guest visit after confirming the code sent to the guest contacts.
         * @param {GuestBookingConfirmDto} guestBookingConfirmDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitSchedulePublicControllerConfirmGuestBooking: async (guestBookingConfirmDto: GuestBookingConfirmDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'guestBookingConfirmDto' is not null or undefined
            assertParamExists('visitSchedulePublicControllerConfirmGuestBooking', 'guestBookingConfirmDto', guestBookingConfirmDto)
            const localVarPath = `/public/visit/schedule/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestBookingConfirmDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Schedule a visit. Public endpoint — no Firebase auth required. Idempotency-Key header is required.
         * @param {string} idempotencyKey
         * @param {PublicScheduleVisitDto} publicScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitSchedulePublicControllerSchedule: async (idempotencyKey: string, publicScheduleVisitDto: PublicScheduleVisitDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('visitSchedulePublicControllerSchedule', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'publicScheduleVisitDto' is not null or undefined
            assertParamExists('visitSchedulePublicControllerSchedule', 'publicScheduleVisitDto', publicScheduleVisitDto)
            const localVarPath = `/public/visit/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (idempotencyKey != null) {
                localVarHeaderParameter['idempotency-key'] = String(idempotencyKey);
            }



            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(publicScheduleVisitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VisitPublicApi - functional programming interface
 * @export
 */
export const VisitPublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VisitPublicApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Signed URL for a private file attached to the visit (via documents collection)
         * @param {string} visitId
         * @param {string} filename
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestAttachmentControllerGetSignedUrl(visitId: string, filename: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitGuestAttachmentControllerGetSignedUrl200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestAttachmentControllerGetSignedUrl(visitId, filename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Guest-session upload of a private file attached to the visit. Returns the GCS filename; the canonical Document row is created by the modal submit (documentsToAdd → updateDetails).
         * @param {string} visitId
         * @param {File} [file]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestAttachmentControllerUploadVisitPrivate(visitId: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VisitGuestAttachmentControllerUploadVisitPrivate201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestAttachmentControllerUploadVisitPrivate(visitId, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Verify the replacement contact, rotate Guest credentials, and send a fresh Manage Link.
         * @param {string} visitId
         * @param {GuestContactChangeCompleteDto} guestContactChangeCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestContactChangeControllerComplete(visitId: string, guestContactChangeCompleteDto: GuestContactChangeCompleteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestContactChangeCompleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestContactChangeControllerComplete(visitId, guestContactChangeCompleteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Send an OTP to a replacement Confirmed Contact for an authenticated Guest Visit.
         * @param {string} visitId
         * @param {GuestContactChangeStartDto} guestContactChangeStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestContactChangeControllerStart(visitId: string, guestContactChangeStartDto: GuestContactChangeStartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestContactChangeStartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestContactChangeControllerStart(visitId, guestContactChangeStartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL visit. 409 if the visit is not in that state.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerApprove(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerApprove(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Cancel the visit (guest-session gated)
         * @param {string} visitId
         * @param {GuestCancelVisitDto} guestCancelVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerCancel(visitId: string, guestCancelVisitDto: GuestCancelVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerCancel(visitId, guestCancelVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Delete a reminder bound to this visit (guest-session gated).
         * @param {string} visitId
         * @param {string} reminderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerDeleteReminder(visitId: string, reminderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerDeleteReminder(visitId, reminderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Return upcoming available slots for the visit professional, for the reschedule modal.
         * @param {string} visitId
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerGetAvailableSlots(visitId: string, slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalSlotsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerGetAvailableSlots(visitId, slotsPerDay, organizationId, duration, startDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Fetch full visit detail for an authenticated guest session. Post-visit content is gated on status.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerGetVisit(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerGetVisit(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror of the URL-token retry). Returns the new P24 checkout URL.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerPaymentRetry(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerPaymentRetry(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Submit a rating for the completed guest visit (guest-session gated). 400 if not a guest visit or not completed; 409 if already rated.
         * @param {string} visitId
         * @param {GuestRateVisitDto} guestRateVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerRate(visitId: string, guestRateVisitDto: GuestRateVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerRate(visitId, guestRateVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL visit (terminal — sessions are revoked). 409 if the visit is not in that state.
         * @param {string} visitId
         * @param {GuestRejectVisitDto} guestRejectVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerReject(visitId: string, guestRejectVisitDto: GuestRejectVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerReject(visitId, guestRejectVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Reschedule the visit (guest-session gated)
         * @param {string} visitId
         * @param {GuestRescheduleVisitDto} guestRescheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerReschedule(visitId: string, guestRescheduleVisitDto: GuestRescheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerReschedule(visitId, guestRescheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit description (\"Dolegliwości\") and attached documents (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {string} visitId
         * @param {GuestUpdateVisitDetailsDto} guestUpdateVisitDetailsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerUpdateDetails(visitId: string, guestUpdateVisitDetailsDto: GuestUpdateVisitDetailsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerUpdateDetails(visitId, guestUpdateVisitDetailsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData (guest-session gated). 400 if the visit is not a guest visit.
         * @param {string} visitId
         * @param {GuestUpdateProfileDataDto} guestUpdateProfileDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerUpdateProfileData(visitId: string, guestUpdateProfileDataDto: GuestUpdateProfileDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerUpdateProfileData(visitId, guestUpdateProfileDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Update a reminder bound to this visit (guest-session gated). Editable fields: description, scheduledAt, notificationChannels.
         * @param {string} visitId
         * @param {string} reminderId
         * @param {GuestUpdateReminderDto} guestUpdateReminderDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerUpdateReminder(visitId: string, reminderId: string, guestUpdateReminderDto: GuestUpdateReminderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerUpdateReminder(visitId, reminderId, guestUpdateReminderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {string} visitId
         * @param {GuestUpdateUserDataDto} guestUpdateUserDataDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerUpdateUserData(visitId: string, guestUpdateUserDataDto: GuestUpdateUserDataDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerUpdateUserData(visitId, guestUpdateUserDataDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get a Twilio video access token for the guest visit (session-gated). 404 if the room is not live.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestManagementPublicControllerVideoToken(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestManagementPublicControllerVideoToken(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Trade a verify code (SMS) or nonce (email magic link) for a guest session.
         * @param {string} visitId
         * @param {string} userAgent
         * @param {GuestVerifyCompleteDto} guestVerifyCompleteDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestVerifyControllerComplete(visitId: string, userAgent: string, guestVerifyCompleteDto: GuestVerifyCompleteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestVerifyCompleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestVerifyControllerComplete(visitId, userAgent, guestVerifyCompleteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Mint a verify challenge for the guest-visit page. Dispatches an email magic link or an SMS code (per `channel`) and returns the masked destination + challenge id.
         * @param {string} visitId
         * @param {GuestVerifyStartDto} guestVerifyStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestVerifyControllerStart(visitId: string, guestVerifyStartDto: GuestVerifyStartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestVerifyStartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestVerifyControllerStart(visitId, guestVerifyStartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Exchange a single-use first-party Voice booking Manage Link for a bounded Guest session.
         * @param {string} userAgent
         * @param {GuestManageLinkStartDto} guestManageLinkStartDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitGuestVerifyControllerStartFromManageLink(userAgent: string, guestManageLinkStartDto: GuestManageLinkStartDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestManageLinkStartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitGuestVerifyControllerStartFromManageLink(userAgent, guestManageLinkStartDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetAllCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetAllCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current payment status for a guest-booked visit.
         * @summary Get the payment status for a guest visit
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetGuestPaymentStatus(visitId: string, guestAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GuestPaymentStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetGuestPaymentStatus(visitId, guestAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns minimal visit info for the confirmation page. Only guest visits (no linked user/profile) are accessible.
         * @summary Fetch the summary for a guest-booked visit
         * @param {string} visitId
         * @param {string} guestAccessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetGuestVisitSummary(visitId: string, guestAccessToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetGuestVisitSummary(visitId, guestAccessToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {string} professionalId
         * @param {string} category
         * @param {number} [slotsPerDay] Maximum number of slots to return per day
         * @param {string} [organizationId] Organization ID to get professional availability from
         * @param {number} [duration] Custom duration in minutes (overrides category default duration)
         * @param {string} [startDate] Earliest start date/time to consider for slots (ISO string). Defaults to now.
         * @param {'video' | 'chat' | 'onsite' | 'mobile'} [visitType] Visit mode required for the availability window
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetProfessionalAvailableSlots(professionalId: string, category: string, slotsPerDay?: number, organizationId?: string, duration?: number, startDate?: string, visitType?: 'video' | 'chat' | 'onsite' | 'mobile', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalSlotsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetProfessionalAvailableSlots(professionalId, category, slotsPerDay, organizationId, duration, startDate, visitType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get available slots for multiple professionals
         * @param {string} category
         * @param {GetProfessionalsSlotsDto} getProfessionalsSlotsDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetProfessionalsAvailableSlots(category: string, getProfessionalsSlotsDto: GetProfessionalsSlotsDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalsSlotsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetProfessionalsAvailableSlots(category, getProfessionalsSlotsDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get availability slots
         * @param {string} category
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetUpcoming2weeksVisitSlots(category: string, organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetUpcoming2weeksVisitSlots(category, organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get upcoming visit slot
         * @param {string} organizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerGetUpcomingVisitSlot(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerGetUpcomingVisitSlot(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Retry a failed guest payment (token-gated). Returns a fresh P24 checkout URL.
         * @param {string} visitId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitPublicControllerRetryGuestPayment(visitId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitPublicControllerRetryGuestPayment(visitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Create a guest visit after confirming the code sent to the guest contacts.
         * @param {GuestBookingConfirmDto} guestBookingConfirmDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitSchedulePublicControllerConfirmGuestBooking(guestBookingConfirmDto: GuestBookingConfirmDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicScheduleVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitSchedulePublicControllerConfirmGuestBooking(guestBookingConfirmDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Schedule a visit. Public endpoint — no Firebase auth required. Idempotency-Key header is required.
         * @param {string} idempotencyKey
         * @param {PublicScheduleVisitDto} publicScheduleVisitDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async visitSchedulePublicControllerSchedule(idempotencyKey: string, publicScheduleVisitDto: PublicScheduleVisitDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicScheduleVisitResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.visitSchedulePublicControllerSchedule(idempotencyKey, publicScheduleVisitDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VisitPublicApi - factory interface
 * @export
 */
export const VisitPublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VisitPublicApiFp(configuration)
    return {
        /**
         *
         * @summary Signed URL for a private file attached to the visit (via documents collection)
         * @param {VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestAttachmentControllerGetSignedUrl(requestParameters: VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest, options?: AxiosRequestConfig): AxiosPromise<VisitGuestAttachmentControllerGetSignedUrl200Response> {
            return localVarFp.visitGuestAttachmentControllerGetSignedUrl(requestParameters.visitId, requestParameters.filename, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Guest-session upload of a private file attached to the visit. Returns the GCS filename; the canonical Document row is created by the modal submit (documentsToAdd → updateDetails).
         * @param {VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestAttachmentControllerUploadVisitPrivate(requestParameters: VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest, options?: AxiosRequestConfig): AxiosPromise<VisitGuestAttachmentControllerUploadVisitPrivate201Response> {
            return localVarFp.visitGuestAttachmentControllerUploadVisitPrivate(requestParameters.visitId, requestParameters.file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Verify the replacement contact, rotate Guest credentials, and send a fresh Manage Link.
         * @param {VisitPublicApiVisitGuestContactChangeControllerCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestContactChangeControllerComplete(requestParameters: VisitPublicApiVisitGuestContactChangeControllerCompleteRequest, options?: AxiosRequestConfig): AxiosPromise<GuestContactChangeCompleteResponseDto> {
            return localVarFp.visitGuestContactChangeControllerComplete(requestParameters.visitId, requestParameters.guestContactChangeCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Send an OTP to a replacement Confirmed Contact for an authenticated Guest Visit.
         * @param {VisitPublicApiVisitGuestContactChangeControllerStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestContactChangeControllerStart(requestParameters: VisitPublicApiVisitGuestContactChangeControllerStartRequest, options?: AxiosRequestConfig): AxiosPromise<GuestContactChangeStartResponseDto> {
            return localVarFp.visitGuestContactChangeControllerStart(requestParameters.visitId, requestParameters.guestContactChangeStartDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Approve a PENDING_APPROVAL visit. 409 if the visit is not in that state.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerApproveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerApprove(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerApproveRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerApprove(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Cancel the visit (guest-session gated)
         * @param {VisitPublicApiVisitGuestManagementPublicControllerCancelRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerCancel(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerCancelRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerCancel(requestParameters.visitId, requestParameters.guestCancelVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a reminder bound to this visit (guest-session gated).
         * @param {VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerDeleteReminder(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerDeleteReminder(requestParameters.visitId, requestParameters.reminderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Return upcoming available slots for the visit professional, for the reschedule modal.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerGetAvailableSlots(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalSlotsResponseDto> {
            return localVarFp.visitGuestManagementPublicControllerGetAvailableSlots(requestParameters.visitId, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Fetch full visit detail for an authenticated guest session. Post-visit content is gated on status.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerGetVisit(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerGetVisit(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry a failed guest payment (session-gated mirror of the URL-token retry). Returns the new P24 checkout URL.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerPaymentRetry(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerPaymentRetry(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Submit a rating for the completed guest visit (guest-session gated). 400 if not a guest visit or not completed; 409 if already rated.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerRateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerRate(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRateRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerRate(requestParameters.visitId, requestParameters.guestRateVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reject a PENDING_APPROVAL visit (terminal — sessions are revoked). 409 if the visit is not in that state.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerRejectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerReject(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRejectRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerReject(requestParameters.visitId, requestParameters.guestRejectVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Reschedule the visit (guest-session gated)
         * @param {VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerReschedule(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerReschedule(requestParameters.visitId, requestParameters.guestRescheduleVisitDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit description (\"Dolegliwości\") and attached documents (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateDetails(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerUpdateDetails(requestParameters.visitId, requestParameters.guestUpdateVisitDetailsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit-embedded pet profileData (guest-session gated). 400 if the visit is not a guest visit.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateProfileData(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerUpdateProfileData(requestParameters.visitId, requestParameters.guestUpdateProfileDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a reminder bound to this visit (guest-session gated). Editable fields: description, scheduledAt, notificationChannels.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateReminder(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerUpdateReminder(requestParameters.visitId, requestParameters.reminderId, requestParameters.guestUpdateReminderDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Patch the visit-embedded owner userData (guest-session gated). 400 if the visit is account-backed (has userId).
         * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerUpdateUserData(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerUpdateUserData(requestParameters.visitId, requestParameters.guestUpdateUserDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a Twilio video access token for the guest visit (session-gated). 404 if the room is not live.
         * @param {VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestManagementPublicControllerVideoToken(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitGuestManagementPublicControllerVideoToken(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Trade a verify code (SMS) or nonce (email magic link) for a guest session.
         * @param {VisitPublicApiVisitGuestVerifyControllerCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerComplete(requestParameters: VisitPublicApiVisitGuestVerifyControllerCompleteRequest, options?: AxiosRequestConfig): AxiosPromise<GuestVerifyCompleteResponseDto> {
            return localVarFp.visitGuestVerifyControllerComplete(requestParameters.visitId, requestParameters.userAgent, requestParameters.guestVerifyCompleteDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Mint a verify challenge for the guest-visit page. Dispatches an email magic link or an SMS code (per `channel`) and returns the masked destination + challenge id.
         * @param {VisitPublicApiVisitGuestVerifyControllerStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerStart(requestParameters: VisitPublicApiVisitGuestVerifyControllerStartRequest, options?: AxiosRequestConfig): AxiosPromise<GuestVerifyStartResponseDto> {
            return localVarFp.visitGuestVerifyControllerStart(requestParameters.visitId, requestParameters.guestVerifyStartDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Exchange a single-use first-party Voice booking Manage Link for a bounded Guest session.
         * @param {VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitGuestVerifyControllerStartFromManageLink(requestParameters: VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest, options?: AxiosRequestConfig): AxiosPromise<GuestManageLinkStartResponseDto> {
            return localVarFp.visitGuestVerifyControllerStartFromManageLink(requestParameters.userAgent, requestParameters.guestManageLinkStartDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all visit categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetAllCategories(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitPublicControllerGetAllCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current payment status for a guest-booked visit.
         * @summary Get the payment status for a guest visit
         * @param {VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetGuestPaymentStatus(requestParameters: VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest, options?: AxiosRequestConfig): AxiosPromise<GuestPaymentStatusResponseDto> {
            return localVarFp.visitPublicControllerGetGuestPaymentStatus(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns minimal visit info for the confirmation page. Only guest visits (no linked user/profile) are accessible.
         * @summary Fetch the summary for a guest-booked visit
         * @param {VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetGuestVisitSummary(requestParameters: VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitPublicControllerGetGuestVisitSummary(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
         * @summary Get available visit slots for a specific professional
         * @param {VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetProfessionalAvailableSlots(requestParameters: VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalSlotsResponseDto> {
            return localVarFp.visitPublicControllerGetProfessionalAvailableSlots(requestParameters.professionalId, requestParameters.category, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, requestParameters.visitType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get available slots for multiple professionals
         * @param {VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetProfessionalsAvailableSlots(requestParameters: VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<ProfessionalsSlotsResponseDto> {
            return localVarFp.visitPublicControllerGetProfessionalsAvailableSlots(requestParameters.category, requestParameters.getProfessionalsSlotsDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get availability slots
         * @param {VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetUpcoming2weeksVisitSlots(requestParameters: VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitPublicControllerGetUpcoming2weeksVisitSlots(requestParameters.category, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get upcoming visit slot
         * @param {VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerGetUpcomingVisitSlot(requestParameters: VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitPublicControllerGetUpcomingVisitSlot(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retry a failed guest payment (token-gated). Returns a fresh P24 checkout URL.
         * @param {VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitPublicControllerRetryGuestPayment(requestParameters: VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.visitPublicControllerRetryGuestPayment(requestParameters.visitId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a guest visit after confirming the code sent to the guest contacts.
         * @param {VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitSchedulePublicControllerConfirmGuestBooking(requestParameters: VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest, options?: AxiosRequestConfig): AxiosPromise<PublicScheduleVisitResponseDto> {
            return localVarFp.visitSchedulePublicControllerConfirmGuestBooking(requestParameters.guestBookingConfirmDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Schedule a visit. Public endpoint — no Firebase auth required. Idempotency-Key header is required.
         * @param {VisitPublicApiVisitSchedulePublicControllerScheduleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        visitSchedulePublicControllerSchedule(requestParameters: VisitPublicApiVisitSchedulePublicControllerScheduleRequest, options?: AxiosRequestConfig): AxiosPromise<PublicScheduleVisitResponseDto> {
            return localVarFp.visitSchedulePublicControllerSchedule(requestParameters.idempotencyKey, requestParameters.publicScheduleVisitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for visitGuestAttachmentControllerGetSignedUrl operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest
 */
export interface VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestAttachmentControllerGetSignedUrl
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestAttachmentControllerGetSignedUrl
     */
    readonly filename: string
}

/**
 * Request parameters for visitGuestAttachmentControllerUploadVisitPrivate operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest
 */
export interface VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivate
     */
    readonly visitId: string

    /**
     *
     * @type {File}
     * @memberof VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivate
     */
    readonly file?: File
}

/**
 * Request parameters for visitGuestContactChangeControllerComplete operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestContactChangeControllerCompleteRequest
 */
export interface VisitPublicApiVisitGuestContactChangeControllerCompleteRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestContactChangeControllerComplete
     */
    readonly visitId: string

    /**
     *
     * @type {GuestContactChangeCompleteDto}
     * @memberof VisitPublicApiVisitGuestContactChangeControllerComplete
     */
    readonly guestContactChangeCompleteDto: GuestContactChangeCompleteDto
}

/**
 * Request parameters for visitGuestContactChangeControllerStart operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestContactChangeControllerStartRequest
 */
export interface VisitPublicApiVisitGuestContactChangeControllerStartRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestContactChangeControllerStart
     */
    readonly visitId: string

    /**
     *
     * @type {GuestContactChangeStartDto}
     * @memberof VisitPublicApiVisitGuestContactChangeControllerStart
     */
    readonly guestContactChangeStartDto: GuestContactChangeStartDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerApprove operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerApproveRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerApproveRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerApprove
     */
    readonly visitId: string
}

/**
 * Request parameters for visitGuestManagementPublicControllerCancel operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerCancelRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerCancelRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerCancel
     */
    readonly visitId: string

    /**
     *
     * @type {GuestCancelVisitDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerCancel
     */
    readonly guestCancelVisitDto: GuestCancelVisitDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerDeleteReminder operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerDeleteReminder
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerDeleteReminder
     */
    readonly reminderId: string
}

/**
 * Request parameters for visitGuestManagementPublicControllerGetAvailableSlots operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlots
     */
    readonly visitId: string

    /**
     * Maximum number of slots to return per day
     * @type {number}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlots
     */
    readonly slotsPerDay?: number

    /**
     * Organization ID to get professional availability from
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlots
     */
    readonly organizationId?: string

    /**
     * Custom duration in minutes (overrides category default duration)
     * @type {number}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlots
     */
    readonly duration?: number

    /**
     * Earliest start date/time to consider for slots (ISO string). Defaults to now.
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlots
     */
    readonly startDate?: string
}

/**
 * Request parameters for visitGuestManagementPublicControllerGetVisit operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerGetVisit
     */
    readonly visitId: string
}

/**
 * Request parameters for visitGuestManagementPublicControllerPaymentRetry operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerPaymentRetry
     */
    readonly visitId: string
}

/**
 * Request parameters for visitGuestManagementPublicControllerRate operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerRateRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerRateRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerRate
     */
    readonly visitId: string

    /**
     *
     * @type {GuestRateVisitDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerRate
     */
    readonly guestRateVisitDto: GuestRateVisitDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerReject operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerRejectRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerRejectRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerReject
     */
    readonly visitId: string

    /**
     *
     * @type {GuestRejectVisitDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerReject
     */
    readonly guestRejectVisitDto: GuestRejectVisitDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerReschedule operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerReschedule
     */
    readonly visitId: string

    /**
     *
     * @type {GuestRescheduleVisitDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerReschedule
     */
    readonly guestRescheduleVisitDto: GuestRescheduleVisitDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerUpdateDetails operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateDetails
     */
    readonly visitId: string

    /**
     *
     * @type {GuestUpdateVisitDetailsDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateDetails
     */
    readonly guestUpdateVisitDetailsDto: GuestUpdateVisitDetailsDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerUpdateProfileData operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileData
     */
    readonly visitId: string

    /**
     *
     * @type {GuestUpdateProfileDataDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileData
     */
    readonly guestUpdateProfileDataDto: GuestUpdateProfileDataDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerUpdateReminder operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateReminder
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateReminder
     */
    readonly reminderId: string

    /**
     *
     * @type {GuestUpdateReminderDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateReminder
     */
    readonly guestUpdateReminderDto: GuestUpdateReminderDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerUpdateUserData operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateUserData
     */
    readonly visitId: string

    /**
     *
     * @type {GuestUpdateUserDataDto}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerUpdateUserData
     */
    readonly guestUpdateUserDataDto: GuestUpdateUserDataDto
}

/**
 * Request parameters for visitGuestManagementPublicControllerVideoToken operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest
 */
export interface VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestManagementPublicControllerVideoToken
     */
    readonly visitId: string
}

/**
 * Request parameters for visitGuestVerifyControllerComplete operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestVerifyControllerCompleteRequest
 */
export interface VisitPublicApiVisitGuestVerifyControllerCompleteRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestVerifyControllerComplete
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestVerifyControllerComplete
     */
    readonly userAgent: string

    /**
     *
     * @type {GuestVerifyCompleteDto}
     * @memberof VisitPublicApiVisitGuestVerifyControllerComplete
     */
    readonly guestVerifyCompleteDto: GuestVerifyCompleteDto
}

/**
 * Request parameters for visitGuestVerifyControllerStart operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestVerifyControllerStartRequest
 */
export interface VisitPublicApiVisitGuestVerifyControllerStartRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestVerifyControllerStart
     */
    readonly visitId: string

    /**
     *
     * @type {GuestVerifyStartDto}
     * @memberof VisitPublicApiVisitGuestVerifyControllerStart
     */
    readonly guestVerifyStartDto: GuestVerifyStartDto
}

/**
 * Request parameters for visitGuestVerifyControllerStartFromManageLink operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest
 */
export interface VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitGuestVerifyControllerStartFromManageLink
     */
    readonly userAgent: string

    /**
     *
     * @type {GuestManageLinkStartDto}
     * @memberof VisitPublicApiVisitGuestVerifyControllerStartFromManageLink
     */
    readonly guestManageLinkStartDto: GuestManageLinkStartDto
}

/**
 * Request parameters for visitPublicControllerGetGuestPaymentStatus operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest
 */
export interface VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetGuestPaymentStatus
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetGuestPaymentStatus
     */
    readonly guestAccessToken: string
}

/**
 * Request parameters for visitPublicControllerGetGuestVisitSummary operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest
 */
export interface VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetGuestVisitSummary
     */
    readonly visitId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetGuestVisitSummary
     */
    readonly guestAccessToken: string
}

/**
 * Request parameters for visitPublicControllerGetProfessionalAvailableSlots operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest
 */
export interface VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly professionalId: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly category: string

    /**
     * Maximum number of slots to return per day
     * @type {number}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly slotsPerDay?: number

    /**
     * Organization ID to get professional availability from
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly organizationId?: string

    /**
     * Custom duration in minutes (overrides category default duration)
     * @type {number}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly duration?: number

    /**
     * Earliest start date/time to consider for slots (ISO string). Defaults to now.
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly startDate?: string

    /**
     * Visit mode required for the availability window
     * @type {'video' | 'chat' | 'onsite' | 'mobile'}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlots
     */
    readonly visitType?: 'video' | 'chat' | 'onsite' | 'mobile'
}

/**
 * Request parameters for visitPublicControllerGetProfessionalsAvailableSlots operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest
 */
export interface VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlots
     */
    readonly category: string

    /**
     *
     * @type {GetProfessionalsSlotsDto}
     * @memberof VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlots
     */
    readonly getProfessionalsSlotsDto: GetProfessionalsSlotsDto
}

/**
 * Request parameters for visitPublicControllerGetUpcoming2weeksVisitSlots operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest
 */
export interface VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlots
     */
    readonly category: string

    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlots
     */
    readonly organizationId: string
}

/**
 * Request parameters for visitPublicControllerGetUpcomingVisitSlot operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest
 */
export interface VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerGetUpcomingVisitSlot
     */
    readonly organizationId: string
}

/**
 * Request parameters for visitPublicControllerRetryGuestPayment operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest
 */
export interface VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitPublicControllerRetryGuestPayment
     */
    readonly visitId: string
}

/**
 * Request parameters for visitSchedulePublicControllerConfirmGuestBooking operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest
 */
export interface VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest {
    /**
     *
     * @type {GuestBookingConfirmDto}
     * @memberof VisitPublicApiVisitSchedulePublicControllerConfirmGuestBooking
     */
    readonly guestBookingConfirmDto: GuestBookingConfirmDto
}

/**
 * Request parameters for visitSchedulePublicControllerSchedule operation in VisitPublicApi.
 * @export
 * @interface VisitPublicApiVisitSchedulePublicControllerScheduleRequest
 */
export interface VisitPublicApiVisitSchedulePublicControllerScheduleRequest {
    /**
     *
     * @type {string}
     * @memberof VisitPublicApiVisitSchedulePublicControllerSchedule
     */
    readonly idempotencyKey: string

    /**
     *
     * @type {PublicScheduleVisitDto}
     * @memberof VisitPublicApiVisitSchedulePublicControllerSchedule
     */
    readonly publicScheduleVisitDto: PublicScheduleVisitDto
}

/**
 * VisitPublicApi - object-oriented interface
 * @export
 * @class VisitPublicApi
 * @extends {BaseAPI}
 */
export class VisitPublicApi extends BaseAPI {
    /**
     *
     * @summary Signed URL for a private file attached to the visit (via documents collection)
     * @param {VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestAttachmentControllerGetSignedUrl(requestParameters: VisitPublicApiVisitGuestAttachmentControllerGetSignedUrlRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestAttachmentControllerGetSignedUrl(requestParameters.visitId, requestParameters.filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Guest-session upload of a private file attached to the visit. Returns the GCS filename; the canonical Document row is created by the modal submit (documentsToAdd → updateDetails).
     * @param {VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestAttachmentControllerUploadVisitPrivate(requestParameters: VisitPublicApiVisitGuestAttachmentControllerUploadVisitPrivateRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestAttachmentControllerUploadVisitPrivate(requestParameters.visitId, requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Verify the replacement contact, rotate Guest credentials, and send a fresh Manage Link.
     * @param {VisitPublicApiVisitGuestContactChangeControllerCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestContactChangeControllerComplete(requestParameters: VisitPublicApiVisitGuestContactChangeControllerCompleteRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestContactChangeControllerComplete(requestParameters.visitId, requestParameters.guestContactChangeCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Send an OTP to a replacement Confirmed Contact for an authenticated Guest Visit.
     * @param {VisitPublicApiVisitGuestContactChangeControllerStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestContactChangeControllerStart(requestParameters: VisitPublicApiVisitGuestContactChangeControllerStartRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestContactChangeControllerStart(requestParameters.visitId, requestParameters.guestContactChangeStartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Approve a PENDING_APPROVAL visit. 409 if the visit is not in that state.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerApproveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerApprove(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerApproveRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerApprove(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Cancel the visit (guest-session gated)
     * @param {VisitPublicApiVisitGuestManagementPublicControllerCancelRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerCancel(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerCancelRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerCancel(requestParameters.visitId, requestParameters.guestCancelVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Delete a reminder bound to this visit (guest-session gated).
     * @param {VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerDeleteReminder(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerDeleteReminderRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerDeleteReminder(requestParameters.visitId, requestParameters.reminderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Return upcoming available slots for the visit professional, for the reschedule modal.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerGetAvailableSlots(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerGetAvailableSlotsRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerGetAvailableSlots(requestParameters.visitId, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Fetch full visit detail for an authenticated guest session. Post-visit content is gated on status.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerGetVisit(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerGetVisitRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerGetVisit(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Retry a failed guest payment (session-gated mirror of the URL-token retry). Returns the new P24 checkout URL.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerPaymentRetry(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerPaymentRetryRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerPaymentRetry(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Submit a rating for the completed guest visit (guest-session gated). 400 if not a guest visit or not completed; 409 if already rated.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerRateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerRate(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRateRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerRate(requestParameters.visitId, requestParameters.guestRateVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reject a PENDING_APPROVAL visit (terminal — sessions are revoked). 409 if the visit is not in that state.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerRejectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerReject(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRejectRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerReject(requestParameters.visitId, requestParameters.guestRejectVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Reschedule the visit (guest-session gated)
     * @param {VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerReschedule(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerRescheduleRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerReschedule(requestParameters.visitId, requestParameters.guestRescheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit description (\"Dolegliwości\") and attached documents (guest-session gated). 400 if the visit is account-backed (has userId).
     * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerUpdateDetails(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateDetailsRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerUpdateDetails(requestParameters.visitId, requestParameters.guestUpdateVisitDetailsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit-embedded pet profileData (guest-session gated). 400 if the visit is not a guest visit.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerUpdateProfileData(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateProfileDataRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerUpdateProfileData(requestParameters.visitId, requestParameters.guestUpdateProfileDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Update a reminder bound to this visit (guest-session gated). Editable fields: description, scheduledAt, notificationChannels.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerUpdateReminder(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateReminderRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerUpdateReminder(requestParameters.visitId, requestParameters.reminderId, requestParameters.guestUpdateReminderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Patch the visit-embedded owner userData (guest-session gated). 400 if the visit is account-backed (has userId).
     * @param {VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerUpdateUserData(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerUpdateUserDataRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerUpdateUserData(requestParameters.visitId, requestParameters.guestUpdateUserDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get a Twilio video access token for the guest visit (session-gated). 404 if the room is not live.
     * @param {VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestManagementPublicControllerVideoToken(requestParameters: VisitPublicApiVisitGuestManagementPublicControllerVideoTokenRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestManagementPublicControllerVideoToken(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Trade a verify code (SMS) or nonce (email magic link) for a guest session.
     * @param {VisitPublicApiVisitGuestVerifyControllerCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestVerifyControllerComplete(requestParameters: VisitPublicApiVisitGuestVerifyControllerCompleteRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestVerifyControllerComplete(requestParameters.visitId, requestParameters.userAgent, requestParameters.guestVerifyCompleteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Mint a verify challenge for the guest-visit page. Dispatches an email magic link or an SMS code (per `channel`) and returns the masked destination + challenge id.
     * @param {VisitPublicApiVisitGuestVerifyControllerStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestVerifyControllerStart(requestParameters: VisitPublicApiVisitGuestVerifyControllerStartRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestVerifyControllerStart(requestParameters.visitId, requestParameters.guestVerifyStartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Exchange a single-use first-party Voice booking Manage Link for a bounded Guest session.
     * @param {VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitGuestVerifyControllerStartFromManageLink(requestParameters: VisitPublicApiVisitGuestVerifyControllerStartFromManageLinkRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitGuestVerifyControllerStartFromManageLink(requestParameters.userAgent, requestParameters.guestManageLinkStartDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all visit categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetAllCategories(options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetAllCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current payment status for a guest-booked visit.
     * @summary Get the payment status for a guest visit
     * @param {VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetGuestPaymentStatus(requestParameters: VisitPublicApiVisitPublicControllerGetGuestPaymentStatusRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetGuestPaymentStatus(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns minimal visit info for the confirmation page. Only guest visits (no linked user/profile) are accessible.
     * @summary Fetch the summary for a guest-booked visit
     * @param {VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetGuestVisitSummary(requestParameters: VisitPublicApiVisitPublicControllerGetGuestVisitSummaryRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetGuestVisitSummary(requestParameters.visitId, requestParameters.guestAccessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns upcoming visit slots for a professional by ID, with optional limit on slots per day
     * @summary Get available visit slots for a specific professional
     * @param {VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetProfessionalAvailableSlots(requestParameters: VisitPublicApiVisitPublicControllerGetProfessionalAvailableSlotsRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetProfessionalAvailableSlots(requestParameters.professionalId, requestParameters.category, requestParameters.slotsPerDay, requestParameters.organizationId, requestParameters.duration, requestParameters.startDate, requestParameters.visitType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get available slots for multiple professionals
     * @param {VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetProfessionalsAvailableSlots(requestParameters: VisitPublicApiVisitPublicControllerGetProfessionalsAvailableSlotsRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetProfessionalsAvailableSlots(requestParameters.category, requestParameters.getProfessionalsSlotsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get availability slots
     * @param {VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetUpcoming2weeksVisitSlots(requestParameters: VisitPublicApiVisitPublicControllerGetUpcoming2weeksVisitSlotsRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetUpcoming2weeksVisitSlots(requestParameters.category, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get upcoming visit slot
     * @param {VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerGetUpcomingVisitSlot(requestParameters: VisitPublicApiVisitPublicControllerGetUpcomingVisitSlotRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerGetUpcomingVisitSlot(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Retry a failed guest payment (token-gated). Returns a fresh P24 checkout URL.
     * @param {VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitPublicControllerRetryGuestPayment(requestParameters: VisitPublicApiVisitPublicControllerRetryGuestPaymentRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitPublicControllerRetryGuestPayment(requestParameters.visitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Create a guest visit after confirming the code sent to the guest contacts.
     * @param {VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitSchedulePublicControllerConfirmGuestBooking(requestParameters: VisitPublicApiVisitSchedulePublicControllerConfirmGuestBookingRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitSchedulePublicControllerConfirmGuestBooking(requestParameters.guestBookingConfirmDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Schedule a visit. Public endpoint — no Firebase auth required. Idempotency-Key header is required.
     * @param {VisitPublicApiVisitSchedulePublicControllerScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VisitPublicApi
     */
    public visitSchedulePublicControllerSchedule(requestParameters: VisitPublicApiVisitSchedulePublicControllerScheduleRequest, options?: AxiosRequestConfig) {
        return VisitPublicApiFp(this.configuration).visitSchedulePublicControllerSchedule(requestParameters.idempotencyKey, requestParameters.publicScheduleVisitDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VoiceDevelopOperatorTrialNoticeApi - axios parameter creator
 * @export
 */
export const VoiceDevelopOperatorTrialNoticeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Pobierz informację o niezweryfikowanej próbie rozwojowej
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialNoticeControllerReadNotice: async (organizationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('voiceDevelopOperatorTrialNoticeControllerReadNotice', 'organizationId', organizationId)
            const localVarPath = `/public/voice-privacy/{organizationId}/develop-operator-trial`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoiceDevelopOperatorTrialNoticeApi - functional programming interface
 * @export
 */
export const VoiceDevelopOperatorTrialNoticeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoiceDevelopOperatorTrialNoticeApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Pobierz informację o niezweryfikowanej próbie rozwojowej
         * @param {string} organizationId Identyfikator ObjectId albo publiczny slug placówki
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voiceDevelopOperatorTrialNoticeControllerReadNotice(organizationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoiceDevelopOperatorTrialNoticeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voiceDevelopOperatorTrialNoticeControllerReadNotice(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VoiceDevelopOperatorTrialNoticeApi - factory interface
 * @export
 */
export const VoiceDevelopOperatorTrialNoticeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoiceDevelopOperatorTrialNoticeApiFp(configuration)
    return {
        /**
         *
         * @summary Pobierz informację o niezweryfikowanej próbie rozwojowej
         * @param {VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voiceDevelopOperatorTrialNoticeControllerReadNotice(requestParameters: VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest, options?: AxiosRequestConfig): AxiosPromise<VoiceDevelopOperatorTrialNoticeDto> {
            return localVarFp.voiceDevelopOperatorTrialNoticeControllerReadNotice(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for voiceDevelopOperatorTrialNoticeControllerReadNotice operation in VoiceDevelopOperatorTrialNoticeApi.
 * @export
 * @interface VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest
 */
export interface VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest {
    /**
     * Identyfikator ObjectId albo publiczny slug placówki
     * @type {string}
     * @memberof VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNotice
     */
    readonly organizationId: string
}

/**
 * VoiceDevelopOperatorTrialNoticeApi - object-oriented interface
 * @export
 * @class VoiceDevelopOperatorTrialNoticeApi
 * @extends {BaseAPI}
 */
export class VoiceDevelopOperatorTrialNoticeApi extends BaseAPI {
    /**
     *
     * @summary Pobierz informację o niezweryfikowanej próbie rozwojowej
     * @param {VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceDevelopOperatorTrialNoticeApi
     */
    public voiceDevelopOperatorTrialNoticeControllerReadNotice(requestParameters: VoiceDevelopOperatorTrialNoticeApiVoiceDevelopOperatorTrialNoticeControllerReadNoticeRequest, options?: AxiosRequestConfig) {
        return VoiceDevelopOperatorTrialNoticeApiFp(this.configuration).voiceDevelopOperatorTrialNoticeControllerReadNotice(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WoocommerceApi - axios parameter creator
 * @export
 */
export const WoocommerceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetCategories: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/woocommerce/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get product details by ID
         * @param {number} productId Product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductById: async (productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('wooCommerceControllerGetProductById', 'productId', productId)
            const localVarPath = `/api/woocommerce/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get products by category ID
         * @param {number} categoryId Category ID
         * @param {number} [page] Page number
         * @param {number} [perPage] Products per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductsByCategory: async (categoryId: number, page?: number, perPage?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('wooCommerceControllerGetProductsByCategory', 'categoryId', categoryId)
            const localVarPath = `/api/woocommerce/products/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WoocommerceApi - functional programming interface
 * @export
 */
export const WoocommerceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WoocommerceApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetCategories(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetCategories(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get product details by ID
         * @param {number} productId Product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetProductById(productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetProductById(productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get products by category ID
         * @param {number} categoryId Category ID
         * @param {number} [page] Page number
         * @param {number} [perPage] Products per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wooCommerceControllerGetProductsByCategory(categoryId: number, page?: number, perPage?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wooCommerceControllerGetProductsByCategory(categoryId, page, perPage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WoocommerceApi - factory interface
 * @export
 */
export const WoocommerceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WoocommerceApiFp(configuration)
    return {
        /**
         *
         * @summary Get all WooCommerce categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetCategories(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.wooCommerceControllerGetCategories(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get product details by ID
         * @param {WoocommerceApiWooCommerceControllerGetProductByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductById(requestParameters: WoocommerceApiWooCommerceControllerGetProductByIdRequest, options?: AxiosRequestConfig): AxiosPromise<ProductResponseDto> {
            return localVarFp.wooCommerceControllerGetProductById(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get products by category ID
         * @param {WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wooCommerceControllerGetProductsByCategory(requestParameters: WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest, options?: AxiosRequestConfig): AxiosPromise<ProductsListResponseDto> {
            return localVarFp.wooCommerceControllerGetProductsByCategory(requestParameters.categoryId, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for wooCommerceControllerGetProductById operation in WoocommerceApi.
 * @export
 * @interface WoocommerceApiWooCommerceControllerGetProductByIdRequest
 */
export interface WoocommerceApiWooCommerceControllerGetProductByIdRequest {
    /**
     * Product ID
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductById
     */
    readonly productId: number
}

/**
 * Request parameters for wooCommerceControllerGetProductsByCategory operation in WoocommerceApi.
 * @export
 * @interface WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest
 */
export interface WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest {
    /**
     * Category ID
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly categoryId: number

    /**
     * Page number
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly page?: number

    /**
     * Products per page
     * @type {number}
     * @memberof WoocommerceApiWooCommerceControllerGetProductsByCategory
     */
    readonly perPage?: number
}

/**
 * WoocommerceApi - object-oriented interface
 * @export
 * @class WoocommerceApi
 * @extends {BaseAPI}
 */
export class WoocommerceApi extends BaseAPI {
    /**
     *
     * @summary Get all WooCommerce categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetCategories(options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get product details by ID
     * @param {WoocommerceApiWooCommerceControllerGetProductByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetProductById(requestParameters: WoocommerceApiWooCommerceControllerGetProductByIdRequest, options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetProductById(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get products by category ID
     * @param {WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WoocommerceApi
     */
    public wooCommerceControllerGetProductsByCategory(requestParameters: WoocommerceApiWooCommerceControllerGetProductsByCategoryRequest, options?: AxiosRequestConfig) {
        return WoocommerceApiFp(this.configuration).wooCommerceControllerGetProductsByCategory(requestParameters.categoryId, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * WordPressApi - axios parameter creator
 * @export
 */
export const WordPressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *
         * @summary Get all blog post slugs for static generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetAllBlogPostSlugs: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/wordpress/posts/slugs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get blog post details by ID
         * @param {number} postId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPostById: async (postId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('wordPressControllerGetBlogPostById', 'postId', postId)
            const localVarPath = `/api/wordpress/posts/id/{postId}`
                .replace(`{${"postId"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get blog post details by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPostBySlug: async (slug: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('wordPressControllerGetBlogPostBySlug', 'slug', slug)
            const localVarPath = `/api/wordpress/posts/slug/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all blog posts
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPosts: async (page?: number, perPage?: number, search?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/wordpress/posts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['perPage'] = perPage;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }



            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WordPressApi - functional programming interface
 * @export
 */
export const WordPressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WordPressApiAxiosParamCreator(configuration)
    return {
        /**
         *
         * @summary Get all blog post slugs for static generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordPressControllerGetAllBlogPostSlugs(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordPressControllerGetAllBlogPostSlugs(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get blog post details by ID
         * @param {number} postId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordPressControllerGetBlogPostById(postId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordPressControllerGetBlogPostById(postId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get blog post details by slug
         * @param {string} slug
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordPressControllerGetBlogPostBySlug(slug: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordPressControllerGetBlogPostBySlug(slug, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *
         * @summary Get all blog posts
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {string} [search]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async wordPressControllerGetBlogPosts(page?: number, perPage?: number, search?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BlogPostsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.wordPressControllerGetBlogPosts(page, perPage, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WordPressApi - factory interface
 * @export
 */
export const WordPressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WordPressApiFp(configuration)
    return {
        /**
         *
         * @summary Get all blog post slugs for static generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetAllBlogPostSlugs(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.wordPressControllerGetAllBlogPostSlugs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get blog post details by ID
         * @param {WordPressApiWordPressControllerGetBlogPostByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPostById(requestParameters: WordPressApiWordPressControllerGetBlogPostByIdRequest, options?: AxiosRequestConfig): AxiosPromise<BlogPostResponseDto> {
            return localVarFp.wordPressControllerGetBlogPostById(requestParameters.postId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get blog post details by slug
         * @param {WordPressApiWordPressControllerGetBlogPostBySlugRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPostBySlug(requestParameters: WordPressApiWordPressControllerGetBlogPostBySlugRequest, options?: AxiosRequestConfig): AxiosPromise<BlogPostResponseDto> {
            return localVarFp.wordPressControllerGetBlogPostBySlug(requestParameters.slug, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all blog posts
         * @param {WordPressApiWordPressControllerGetBlogPostsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wordPressControllerGetBlogPosts(requestParameters: WordPressApiWordPressControllerGetBlogPostsRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BlogPostsListResponseDto> {
            return localVarFp.wordPressControllerGetBlogPosts(requestParameters.page, requestParameters.perPage, requestParameters.search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for wordPressControllerGetBlogPostById operation in WordPressApi.
 * @export
 * @interface WordPressApiWordPressControllerGetBlogPostByIdRequest
 */
export interface WordPressApiWordPressControllerGetBlogPostByIdRequest {
    /**
     *
     * @type {number}
     * @memberof WordPressApiWordPressControllerGetBlogPostById
     */
    readonly postId: number
}

/**
 * Request parameters for wordPressControllerGetBlogPostBySlug operation in WordPressApi.
 * @export
 * @interface WordPressApiWordPressControllerGetBlogPostBySlugRequest
 */
export interface WordPressApiWordPressControllerGetBlogPostBySlugRequest {
    /**
     *
     * @type {string}
     * @memberof WordPressApiWordPressControllerGetBlogPostBySlug
     */
    readonly slug: string
}

/**
 * Request parameters for wordPressControllerGetBlogPosts operation in WordPressApi.
 * @export
 * @interface WordPressApiWordPressControllerGetBlogPostsRequest
 */
export interface WordPressApiWordPressControllerGetBlogPostsRequest {
    /**
     *
     * @type {number}
     * @memberof WordPressApiWordPressControllerGetBlogPosts
     */
    readonly page?: number

    /**
     *
     * @type {number}
     * @memberof WordPressApiWordPressControllerGetBlogPosts
     */
    readonly perPage?: number

    /**
     *
     * @type {string}
     * @memberof WordPressApiWordPressControllerGetBlogPosts
     */
    readonly search?: string
}

/**
 * WordPressApi - object-oriented interface
 * @export
 * @class WordPressApi
 * @extends {BaseAPI}
 */
export class WordPressApi extends BaseAPI {
    /**
     *
     * @summary Get all blog post slugs for static generation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WordPressApi
     */
    public wordPressControllerGetAllBlogPostSlugs(options?: AxiosRequestConfig) {
        return WordPressApiFp(this.configuration).wordPressControllerGetAllBlogPostSlugs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get blog post details by ID
     * @param {WordPressApiWordPressControllerGetBlogPostByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WordPressApi
     */
    public wordPressControllerGetBlogPostById(requestParameters: WordPressApiWordPressControllerGetBlogPostByIdRequest, options?: AxiosRequestConfig) {
        return WordPressApiFp(this.configuration).wordPressControllerGetBlogPostById(requestParameters.postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get blog post details by slug
     * @param {WordPressApiWordPressControllerGetBlogPostBySlugRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WordPressApi
     */
    public wordPressControllerGetBlogPostBySlug(requestParameters: WordPressApiWordPressControllerGetBlogPostBySlugRequest, options?: AxiosRequestConfig) {
        return WordPressApiFp(this.configuration).wordPressControllerGetBlogPostBySlug(requestParameters.slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *
     * @summary Get all blog posts
     * @param {WordPressApiWordPressControllerGetBlogPostsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WordPressApi
     */
    public wordPressControllerGetBlogPosts(requestParameters: WordPressApiWordPressControllerGetBlogPostsRequest = {}, options?: AxiosRequestConfig) {
        return WordPressApiFp(this.configuration).wordPressControllerGetBlogPosts(requestParameters.page, requestParameters.perPage, requestParameters.search, options).then((request) => request(this.axios, this.basePath));
    }
}


